import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./pages/login";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
  Redirect,
  useLocation,
} from "react-router-dom";
import Register from "./pages/register";
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import Notifications from "./pages/Notification/notification";
import { connect, useDispatch, useSelector } from "react-redux";
import { DndProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import AddCompany from "./pages/Company/addcompany";
import ForgotPassword from "./pages/ForgotPassword";
import { LanguageProvider } from "./helper/LanguageContext";
import { setCurrentBranchLang } from "./Languages/vars/branchI18n";
import { loadCustomBranches } from "./helper/customBranches";
import Contact from "./pages/contact";
import EditProfile from "./pages/Profile/EditProfile";
import AddProject from "./pages/Project/AddProject";
import Capacities from "./pages/capacities";
import FreeCapacity from "./pages/Company/FreeCapacity";
import Project from "./pages/Project/project";
import Company from "./pages/Company/company";
import ProfileSetting from "./pages/Profile/ProfileSetting";
import Articles from "./pages/Feeds/Articles";
import { ConfirmDialog, NotifySnackbar } from "react-material-crud";
import ArticleLike from "./pages/Feeds/ArticleLike";
import MyCompany from "./pages/Company/mycompany";
import UserProfile from "./pages/User/UserProfile";
import DirectMessagePrompt from "./components/DirectMessagePrompt";
import Followings from "./pages/Feeds/Followings";
import UserFollowings from "./pages/User/UserFollowings";
import Followers from "./pages/Feeds/Followers";
import UserFollowers from "./pages/User/UserFollowers";
import EditCompany from "./pages/Company/EditCompany";
import CompanyUser from "./pages/Company/CompanyUser";
import ForeignCompanyDetails from "./pages/User/ForeignCompanyDetails";
import CompanyFollowers from "./pages/Company/CompanyFollowers";
import CompanySetting from "./pages/Company/CompanySetting";
import CompanyAdmin, { KjuupIoAboPage } from "./pages/Company/CompanyAdmin";
import ExternalMit from "./pages/Company/Invite";
import CompanyServicesMember from "./pages/Company/CompanyServicesMember";
import AddServices from "./pages/Services/AddServices";
import ProjectDetail from "./pages/Project/ProjectDetail";
import AddProjectUser from "./pages/Project/AddProjectUser";
import InviteProjectUser from "./pages/Project/InviteProjectUser";
import MediaLinksDocs from "./pages/Project/MediaLinksDocs";
import FeedDetail from "./pages/Feeds/FeedDetail";
import EditProject from "./pages/Project/EditProject";
import Companies from "./pages/Company/Companies";
import CreateCompanyArticle from "./pages/Feeds/CreateCompanyArticle";
import CompanyDocuments from "./pages/CompanyDocuments/CompanyDocuments";
import EditCompanyArticle from "./pages/Feeds/EditCompanyArticle";
import AddOneToOneUser from "./pages/Chat/AddOneToOneUser";
import WeeklyStatistics from "./pages/Notification/WeeklyStatistics";
import AllContact from "./pages/Notification/AllContact";
import _ from "lodash";
import { badgeCountObj, buildBadgeSubscribeRequest, onlineObj, SOCKET_BASE } from "./helper/SocketObj";
import { getBadgeCount, invalidateBadgeCount } from "./helper/badgeCount";
import {
  ALL_BADGE_COUNT,
  ARTICLE_BADGE_BUMP,
  ARTICLE_FEED_SEEN,
  BUMP_CHAT_REACTION,
  CHAT_BADGE_COUNT,
  GET_COUNTERS,
  GROUPS,
  INTERNAL_PROJECTS,
  IS_NEW_MESSAGE,
  NEWS_BADGE_COUNT,
  OPEN_PROJECTS,
  OPEN_BOTTOM_PROJECTS,
  OPEN_CHATS,
  OPEN_BOTTOM_CHATS,
  PROJECTS,
  PROJECT_BADGE_COUNT,
  RESET_SOCKET,
  RIGHT_TOP,
  SET_ALLGROUPS_PROJECTS,
  LANGUAGE,
  SET_AUTO_TRANSLATION,
  SET_AUTO_TRANSLATION_LANGUAGES,
  SET_TRANSLATE_ROOM_AND_GROUP_NAMES,
  SET_DOCUMENT_CONTENT_SEARCH,
  SET_IS_UNAUTHORIZED,
  SET_JOIN_REQUEST_EXTERNAL,
  SET_JOIN_REQUEST_INTERNAL,
  SET_OPEN_SIDE_BAR,
  SET_PINNED_ROOMS,
  SET_RUNNING_CALLS,
  SET_USER_LOGIN_TOKEN,
  SHOW_LIST_ONGOING,
  UNSEEN_EXTERNAL_BADGE,
  UNSEEN_INTERNAL_BADGE,
  UPDATE_PROJECT_ACTION_FIRE,
  store,
  TOGGLE_CHAT,
  FETCH_ALL_REQUEST,
  SET_DEEPLINK_LOADING,
  SET_DEEPLINK_DATA,
  EMAIL_SYNC,
  EMAIL_ACCOUNTS_CHANGED,
  EMAIL_CATCH_UP,
  MY_SPACE_PINNED,
  RESET_LATEST_MESSAGES,
  INCREMENT_UNSEEN_TODO_COUNT,
  INCREMENT_UNSEEN_DAILY_BRIEFING_COUNT,
  INCREMENT_UNSEEN_ALL_SCOPE_DAILY_BRIEFING_COUNT,
  REFRESH_TODO_LIST,
  TODO_CALENDAR_DELETED,
  TODO_CALENDAR_REMOVED,
  CLEAR_SUBSCRIPTION,
  allowBadgeIncreases,
} from "./store";
import { fetchAndStoreSubscriptionStatus } from "./services/PaymentService";
import { shouldShowDailyBriefingCounters } from "./utils/dailyBriefingCounters";
import { navigateToChatDeeplink } from "./helper/chatDeeplink";
import { appendCachedMessage } from "./helper/chatMessageCache";
import {
  initWebPush,
  notifyChatIfBackground,
  notifyIfBackground,
  parseChatPayloadFromPush,
  consumeChatQueryParams,
  consumeTodoQueryParams,
} from "./utils/webPushNotifications";
import SubscriptionPage from "./pages/Subscription/SubscriptionPage";
import Home from "./pages/home";
import InfoPage from "./pages/InfoPage";
import { CardonContainer } from "cardon";
import RightBar from "./components/RightBar";
import SideNav from "./SideNav";
import { callAPI, key_pair, refreshAccessToken, setSuppressUnauthorized } from "./helper/apiUtils";
import FollowOneToOne from "./pages/Chat/FollowOneToOne";
import { SocketContext } from "./context/socket";
import { PaneActiveContext } from "./context/paneActive";
import SecurityPIN from "./pages/SecurityPIN";
import TwoFactorChallenge from "./pages/TwoFactorChallenge";
import SecurityPINMain from "./pages/SecurityPINMain";
import { API_ROOT, KJUUP_COLORS } from "./helper/constants";
import appConfig from "./config/appConfig";
import socketio from "socket.io-client";
import { $user } from "./helper/UserFactory";
import { firstEmailSentence } from "./helper/emailBodyFormat";
import customParser from "socket.io-msgpack-parser";
import LatestMessages from "./pages/Feeds/LatestMessages";
import { openProjectTask } from "./pages/Cockpit/cockpitNavigation";
import { DE } from "./Languages/DE";
import { EN } from "./Languages/EN";
import { FR } from "./Languages/FR";
import { IT } from "./Languages/IT";
import { ES } from "./Languages/ES";
import { PT } from "./Languages/PT";
import { RU } from "./Languages/RU";
import { PL } from "./Languages/PL";
import { NL } from "./Languages/NL";
import { TR } from "./Languages/TR";
import { EL } from "./Languages/EL";
import { CS } from "./Languages/CS";
import { HU } from "./Languages/HU";
import { RO } from "./Languages/RO";
import { BG } from "./Languages/BG";
import { HR } from "./Languages/HR";
import { SL } from "./Languages/SL";
import { SK } from "./Languages/SK";
import { SV } from "./Languages/SV";
import { NO } from "./Languages/NO";
import { DA } from "./Languages/DA";
import { FI } from "./Languages/FI";
import { ZH } from "./Languages/ZH";
import { HI } from "./Languages/HI";
import { AR } from "./Languages/AR";
import { JA } from "./Languages/JA";
import { KO } from "./Languages/KO";
import { VI } from "./Languages/VI";
import { ID } from "./Languages/ID";
import { MS } from "./Languages/MS";
import { BN } from "./Languages/BN";
import { TA } from "./Languages/TA";
import { TE } from "./Languages/TE";
import { MR } from "./Languages/MR";
import { GSW } from "./Languages/GSW";
import { WAE } from "./Languages/WAE";
import { Link, useHistory } from "react-router-dom";
import { version } from '../package.json';
import Loading from "./components/Loading";
import { $crud } from "./helper/CrudFactory";
import { compare } from 'compare-versions';
import OngoingCallsListPopup from "./components/OngoingCallsListPopup";
import { isCallActiveForMe } from "./utils/callTab";
import {
  getStartupRoute,
  getStartupScreenFromUser,
  consumeQueuedStartupNavigation,
  persistStartupScreen,
  captureIncomingDeeplink,
  getPendingDeeplink,
  isDeeplinkPath,
  isOnStartupScreen,
} from "./utils/startupScreen";
import Cockpit from "./pages/Cockpit/Cockpit";
import featureFlags from "./featureFlags";
import MyProject from "./pages/Project/MyProject";
import FullScreenImageViewer from "./components/FullScreenImageViewer";
import { useScreenDetector } from './useScreenDetector';
import SafeArea from './components/SafeArea';
import DeeplinkHandler from "./pages/DeeplinkHandler";
import KjuupSupportModal from "./components/KjuupSupportModal";
import ImpersonationLoader from "./components/ImpersonationLoader";
import { resolvePackageId } from "./utils/packageTheme";
import { TEAMS_ACCOUNT_EVENT, relayTeamsSocketEvents } from "./utils/teams/teamsConnect";
import { teamsText } from "./utils/teams/teamsCore";
import { TEAMS_UNREAD_EVENT } from "./utils/teams/teamsChats";
import "./AppShell.css";

// Language map for easy lookup - all 34 supported languages
const LANGUAGE_MAP = {
  en: EN,
  de: DE,
  fr: FR,
  it: IT,
  es: ES,
  pt: PT,
  ru: RU,
  pl: PL,
  nl: NL,
  tr: TR,
  el: EL,
  cs: CS,
  hu: HU,
  ro: RO,
  bg: BG,
  hr: HR,
  sl: SL,
  sk: SK,
  sv: SV,
  no: NO,
  da: DA,
  fi: FI,
  zh: ZH,
  hi: HI,
  ar: AR,
  ja: JA,
  ko: KO,
  vi: VI,
  id: ID,
  ms: MS,
  bn: BN,
  ta: TA,
  te: TE,
  mr: MR,
  gsw: GSW,
  wae: WAE,
};

// A key a language file does not have yet shows in Standard German for the
// dialects and in English for every other language, never as a component's
// German fallback text.
const mergedStrings = new Map();
function stringsFor(language) {
  const own = LANGUAGE_MAP[language];
  if (!own) return EN;
  if (own === EN || own === DE) return own;
  if (!mergedStrings.has(language)) {
    const base = language === "gsw" || language === "wae" ? DE : EN;
    mergedStrings.set(language, { ...base, ...own });
  }
  return mergedStrings.get(language);
}

function clipEmailPreview(text, max = 200) {
  return String(text || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim().slice(0, max);
}

function emailPushSummary(msg) {
  if (!msg) return "";
  let summaryEnabled = false;
  try {
    const stored = JSON.parse(localStorage.getItem("user") || "null");
    summaryEnabled = !!(stored && stored.emailSummaryPreviewEnabled);
  } catch (_) {}
  if (summaryEnabled) {
    return firstEmailSentence(msg.snippet) || firstEmailSentence(msg.bodyText || msg.bodyPreview) || clipEmailPreview(msg.subject);
  }
  return firstEmailSentence(msg.bodyText || msg.bodyPreview || msg.snippet) || clipEmailPreview(msg.subject);
}

function emailPushSender(msg, fallback) {
  let from = msg && msg.fromAddress;
  if (typeof from === "string") {
    try { from = JSON.parse(from); } catch (e) { from = null; }
  }
  if (from && typeof from === "object") {
    return from.name || from.email || fallback;
  }
  return fallback;
}

// Cockpit (personal start page) owns "/" and "/cockpit"; the news feed lives
// on "/articles". With the cockpit flag off, "/" falls back to the feed.
function isCockpitPath(pathname) {
  return featureFlags.enableCockpit && (pathname === "/" || pathname === "/cockpit");
}

function CompanyProfileRedirect() {
  const { pathname } = useLocation();
  const id = (pathname.match(/^\/company-details\/([^/]+)/) || [])[1];
  return (
    <Redirect
      to={{
        pathname: "/cockpit",
        search: id ? `?tab=company&company=${encodeURIComponent(id)}` : "?tab=company",
      }}
    />
  );
}

function isHomePath(pathname) {
  if (pathname === "/articles") return true;
  return pathname === "/" && !featureFlags.enableCockpit;
}

// Soft fade-in whenever a page becomes visible. Opacity only: a transform here
// would become the containing block for position:fixed children (modals, FABs).
const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

function usePageFadeIn(ref, active, key) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!active || !el?.animate || prefersReducedMotion()) return;
    const anim = el.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: 180,
      easing: "cubic-bezier(0.22, 1, 0.36, 1)",
    });
    return () => anim.cancel();
  }, [ref, active, key]);
}

function KeepAlivePane({ active, children }) {
  const seenRef = useRef(active);
  const paneRef = useRef(null);
  usePageFadeIn(paneRef, active);
  if (active) seenRef.current = true;
  if (!seenRef.current) return null;
  return (
    <div
      ref={paneRef}
      style={{
        display: active ? "flex" : "none",
        flexDirection: "column",
        flex: active ? "1 1 auto" : "0 0 0px",
        minHeight: 0,
        minWidth: 0,
        height: active ? "100%" : 0,
        width: "100%",
        overflow: "hidden",
      }}
    >
      <PaneActiveContext.Provider value={!!active}>{children}</PaneActiveContext.Provider>
    </div>
  );
}

function MainColumn({ children }) {
  const { pathname } = useLocation();
  const onMessages = pathname === "/messages";
  const onCockpit = isCockpitPath(pathname);
  const onHome = isHomePath(pathname);
  const onTodo = pathname === "/todo";
  const onProfile = pathname === "/profile";
  const onSettings = pathname === "/profile-setting";
  const onCompanies = pathname === "/my-companies";
  const onDocs = pathname.startsWith("/company-documents");
  const onCompany = pathname.startsWith("/company-details/");
  const showRoute = !(onMessages || onCockpit || onHome || onTodo || onProfile || onSettings || onCompanies || onDocs || onCompany);
  const routeRef = useRef(null);
  usePageFadeIn(routeRef, showRoute, pathname);
  return (
    <>
      <KeepAlivePane active={onMessages}><LatestMessages /></KeepAlivePane>
      {featureFlags.enableCockpit ? (
        <KeepAlivePane active={onCockpit}><Cockpit /></KeepAlivePane>
      ) : null}
      <KeepAlivePane active={onHome}><Articles /></KeepAlivePane>
      {/* Tasks live inside projects; the old ToDo page lands on the cockpit. */}
      {onTodo ? <Redirect to="/" /> : null}
      {/* The personal profile page is retired; old links land on the start page. */}
      {onProfile ? <Redirect to="/" /> : null}
      <KeepAlivePane active={onSettings}><ProfileSetting /></KeepAlivePane>
      <KeepAlivePane active={onCompanies}><MyCompany /></KeepAlivePane>
      <KeepAlivePane active={onDocs}><CompanyDocuments /></KeepAlivePane>
      {onCompany ? <CompanyProfileRedirect /> : null}
      <div
        ref={routeRef}
        style={{
          display: showRoute ? "flex" : "none",
          flex: "1 1 auto",
          flexDirection: "column",
          minHeight: 0,
          minWidth: 0,
          height: showRoute ? "100%" : 0,
          width: "100%",
          overflow: "hidden",
        }}
      >
        {children}
      </div>
    </>
  );
}

function App(props) {

  useScreenDetector();
  const isSearchOpen = useSelector(state => state.isSearchOpen);

  let userLang = localStorage.getItem("user");
  let filterLang = JSON.parse(userLang)?.language === "de" ? true : false;
  const {
    drawerOpen,
    unSeenAllCount,
    groupChats,
    projects,
    openProjects,
    openBottomProjects,
    internalProjectsAll,
    joinRequestsExternal,
    groups,
    resetSocket,
    AllGroupsOfProjects,
    selectedCompanyId,
    user,
    userLoginToken
  } = useSelector((state) => state);
  const profile = useSelector((state) => state.profile);
  const subscriptionState = useSelector((state) => state.subscription);

  useEffect(() => {
    const pkg = resolvePackageId(profile, subscriptionState);
    document.documentElement.setAttribute("data-kjuup-package", pkg);
    document.documentElement.setAttribute("data-kjuup-io", pkg === "io" ? "on" : "off");
  }, [profile, subscriptionState]);
  const [isLoggedIn, setIsLoggedIn] = useState();
  // Admin "Sign in as user" overlay: initialized eagerly from the URL so the
  // very first render is the branded loader (no flicker of login/home screen
  // with the previous user's data while we switch sessions).
  const [isImpersonating, setIsImpersonating] = useState(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.get('impersonate_token') || params.get('impersonate_code')) return true;
      return Boolean(
        sessionStorage.getItem('kjuup_impersonate_token') ||
        sessionStorage.getItem('kjuup_impersonate_code')
      );
    } catch (e) {
      return false;
    }
  });
  const [impersonationStatus, setImpersonationStatus] = useState('Preparing your session…');
  const [impersonationSubtext, setImpersonationSubtext] = useState('');
  const [impersonationVariant, setImpersonationVariant] = useState('loading');
  const dispatch = useDispatch();
  const openChatToggle = useSelector(state => state.openChatToggle);
  const [openUserToggle, setOpenUserToggle] = useState(false);
  const [Socket, setSocket] = useState(null);
  const socketRef = useRef(null);
  // New language system - string-based language code
  // Read from 'language' localStorage if available, otherwise fall back to switch-based detection
  const [language, setLanguage] = useState(() => {
    const storedLang = localStorage.getItem("language");
    // Check if stored language is in LANGUAGE_MAP (supports all languages incl. dialects)
    if (storedLang && LANGUAGE_MAP[storedLang]) {
      return storedLang;
    }
    return localStorage.getItem("switch") === "2" ? 'de' : 'en';
  });
  let [isGerm, setIsGerm] = useState(() => {
    const storedLang = localStorage.getItem("language");
    if (storedLang === 'de' || storedLang === 'gsw' || storedLang === 'wae') return true;
    return localStorage.getItem("switch") === "2";
  });
  const [isChatCountProjects, setIsChatCountProjects] = useState(false);
  const [isChatCount, setIsChatCount] = useState(false);
  const [updateCalls, setUpdateCalls] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isVisible, setIsVisible] = useState(!document.hidden);
  const isUnauthorized = useSelector(state => state.isUnauthorized)
  const runningCalls = useSelector(state => state.runningCalls)
  const history = useHistory();
  const isDesktopResolution = useSelector(state => state.isDeskTopResolution);
  const activeSideBar = useSelector(e => e.activeSideBar)
  const isLoading = useSelector(state => state.deeplinkLoading);
  const deeplinkLoadingMessage = useSelector(state => state.deeplinkLoadingMessage);
  const deeplinkData = useSelector(state => state.deeplinkData);
  const deeplinkLoadingInternal = useSelector(state => state.deeplinkLoadingInternal);
  // Use stored deeplinkLoadingInternal flag, which persists even after deeplinkData is cleared
  const isInternalLoading = deeplinkLoadingInternal || deeplinkData?.isInternal || false;
  const rightTop = useSelector(state => state.rightTop);
  const globalLoader = useSelector(state => state.loader);
  
  // Debug logging
  useEffect(() => {
    console.log("=== Redux State Debug ===");
    console.log("activeSideBar:", activeSideBar);
    console.log("rightTop:", rightTop);
    console.log("pathname:", history.location.pathname);
    console.log("========================");
  }, [activeSideBar, rightTop, history.location.pathname]);

  useEffect(() => {
    if (isUnauthorized && !isImpersonating) {
      _logout()
    }
  }, [isUnauthorized, isImpersonating])

  // Legacy-session upgrade: a session that has an access token but no refresh
  // token (older login, registration, or an impersonation redeem) is exchanged
  // for a fresh access + refresh pair while the access token is still valid, so
  // it moves onto the short-access + refresh scheme without a forced re-login.
  useEffect(() => {
    if (isImpersonating) return;
    try {
      if ($user.getToken() && !$user.getRefreshToken()) {
        refreshAccessToken();
      }
    } catch (_) {}
  }, [])

  // Admin-created personal/company industry branches (public catalogue).
  useEffect(() => {
    loadCustomBranches().catch(() => {});
  }, [])

  useEffect(() => {
    if (!isLoading) return;
    const safetyTimer = setTimeout(() => {
      console.warn('[DeeplinkLoader] Safety timeout — dismissing stuck loading overlay');
      dispatch({ type: SET_DEEPLINK_LOADING, loading: false });
      dispatch({ type: SET_DEEPLINK_DATA, payload: null });
    }, 15000);
    return () => clearTimeout(safetyTimer);
  }, [isLoading])

  // Hide empty-label dialog buttons and force confirm-button colors via inline styles
  useEffect(() => {
    const COLORS = { orange: 'var(--kjuup-accent)', green: 'var(--kjuup-internal)', violet: '#e24bf5' };

    const observer = new MutationObserver(() => {
      const labels = document.querySelectorAll('.MuiDialogActions-root .MuiButton-label');
      if (!labels.length) return;

      const explicit = document.body.getAttribute('data-confirm-color');
      const isKjuupPlus = document.body.hasAttribute('data-kjuup-plus') ||
                          document.body.classList.contains('kjuup-plus');
      const kjuupIoOn = document.documentElement.getAttribute('data-kjuup-package') === 'io';
      const color = explicit === 'green' ? COLORS.green
                             : explicit === 'violet' ? COLORS.violet
                             : explicit === 'orange' ? (kjuupIoOn ? COLORS.violet : COLORS.orange)
                             : (isKjuupPlus ? COLORS.green : (kjuupIoOn ? COLORS.violet : COLORS.orange));

      labels.forEach(label => {
        const btn = label.closest('button');
        if (!btn) return;
        if (label.textContent.trim() === '') { btn.style.display = 'none'; return; }
        const isFocused = btn.classList.contains('Mui-focusVisible') ||
                          btn === document.activeElement;
        btn.style.setProperty('border-color', color, 'important');
        if (isFocused) {
          btn.style.setProperty('background-color', color, 'important');
          btn.style.setProperty('color', '#fff', 'important');
          label.style.setProperty('color', '#fff', 'important');
        } else {
          btn.style.setProperty('background-color', '#fff', 'important');
          btn.style.setProperty('color', color, 'important');
          label.style.setProperty('color', color, 'important');
        }
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const disableAutocomplete = () => {
      document.querySelectorAll('input:not([data-ac-set])').forEach(input => {
        input.setAttribute('autocomplete', 'off');
        input.setAttribute('data-ac-set', '1');
      });
    };
    disableAutocomplete();
    const acObserver = new MutationObserver(disableAutocomplete);
    acObserver.observe(document.body, { childList: true, subtree: true });
    return () => acObserver.disconnect();
  }, []);

  const toogleChat = () => {
    dispatch({ type: TOGGLE_CHAT });
  }
  const _logout = async () => {
    captureIncomingDeeplink();
    cleanupSocket();
    dispatch({ type: RESET_SOCKET, payload: true })
    await $user.logout();
    localStorage.removeItem("autoTrans")
    localStorage.removeItem("autoTranslationLanguages")
    localStorage.removeItem("translateRoomAndGroupNames")
    dispatch({ type: SET_AUTO_TRANSLATION, status: true })
    dispatch({ type: SET_AUTO_TRANSLATION_LANGUAGES, languages: null })
    dispatch({ type: SET_TRANSLATE_ROOM_AND_GROUP_NAMES, status: false })
    dispatch({ type: SET_USER_LOGIN_TOKEN, status: null })
    dispatch({ type: SET_IS_UNAUTHORIZED, status: false })
    dispatch({ type: CLEAR_SUBSCRIPTION })
    history.push('/')
  }

  useEffect(() => {
    function onlineHandler() {
      setIsOnline(true);
    }

    function offlineHandler() {
      setIsOnline(false);
    }

    window.addEventListener("online", onlineHandler);
    window.addEventListener("offline", offlineHandler);

    return () => {
      window.removeEventListener("online", onlineHandler);
      window.removeEventListener("offline", offlineHandler);
    };
  }, []);

  function clearCache() {
    try {
      if (window.caches) {
        return caches.keys().then(function (names) {
          return Promise.all(
            names.map(function (name) {
              return caches.delete(name);
            })
          );
        });
      }
      return Promise.resolve();
    } catch (error) {
      console.log('Error clearing cache:', error);
      return Promise.resolve();
    }
  }

  useEffect(() => {
    _checkAndSet();
  }, []);

  const _checkAndSet = async (key, value) => {
    // Auto translation is always enabled — no user toggle.
    dispatch({ type: SET_AUTO_TRANSLATION, status: true });
    localStorage.setItem("autoTrans", "true");
    try {
      const raw = localStorage.getItem("autoTranslationLanguages");
      if (raw) {
        const parsed = JSON.parse(raw);
        // [] is treated as "all enabled" (null); never keep an empty deny-all list.
        const languages = Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
        if (languages == null) localStorage.removeItem("autoTranslationLanguages");
        dispatch({
          type: SET_AUTO_TRANSLATION_LANGUAGES,
          languages,
        });
      }
    } catch (e) {}
  };

  useEffect(() => {
    clearCache();
  }, []);

  const _setUserOffline = async () => {
    const { data } = await callAPI("/user/offline", {}, "GET");
  };

  useEffect(() => {
    if (userLoginToken) {
      getProfile()
      getBadgesCount()
      fetchAndStoreSubscriptionStatus(dispatch)
      if ($user.getToken() && user) {
        cleanupSocket();
        let tkn = $user.getToken();
        let firetoken = user.fcmId;
        connectWithSocket(tkn, firetoken);
        _getRuuningCalls()
        // Read the actual stored language, not just switch
        const storedLang = localStorage.getItem("language");
        // Check if stored language is in LANGUAGE_MAP (supports all 22 languages)
        if (storedLang && LANGUAGE_MAP[storedLang]) {
          setIsGerm(storedLang === 'de');
          setLanguage(storedLang);
        } else {
          // Fall back to switch for backward compatibility
          let lang = localStorage.getItem("switch");
          if (lang == "2") {
            setIsGerm(true);
            setLanguage('de');
          } else {
            setIsGerm(false);
            setLanguage('en');
          }
        }
      } else {
        cleanupSocket();
      }
    } else {
      cleanupSocket();
    }
    return () => cleanupSocket();
  }, [userLoginToken]);

  // A task push / banner: the task's project, on Aufgaben, with the task open.
  // `buildingId` is the task's project (older pushes lack it: GET /todo/:id).
  const openTodoFromPush = useCallback((raw) => {
    const todoId = raw && (raw.todoId || raw.id);
    const roomId = raw && (raw.buildingId || raw.roomId);
    openProjectTask(dispatch, history, { todoId: todoId || null, roomId: roomId || null });
  }, [dispatch, history]);

  const openChatFromPush = useCallback((raw) => {
    if (raw && (raw.model === "todo" || raw.path === "/todo")) {
      openTodoFromPush(raw);
      return;
    }
    // The IT admin approved Kjuup for Microsoft Teams (TeamsConsentService): connect it now.
    if (raw && raw.model === "teamsConsent") {
      history.push("/profile-setting?section=teams");
      return;
    }
    const payload = parseChatPayloadFromPush(raw) || (raw && raw.chatGroupId ? raw : null);
    if (!payload || !payload.chatGroupId) return;
    navigateToChatDeeplink({ dispatch, history, ...payload });
  }, [dispatch, history, openTodoFromPush]);

  useEffect(() => {
    if (!userLoginToken) return;
    initWebPush({ onNotificationClick: openChatFromPush });
    const fromUrl = consumeTodoQueryParams() || consumeChatQueryParams();
    if (fromUrl) {
      const t = setTimeout(() => openChatFromPush(fromUrl), 500);
      return () => clearTimeout(t);
    }
  }, [userLoginToken, openChatFromPush]);

  // `force` skips the post-flight reuse cache in `getBadgeCount()`. Pass
  // `true` whenever we just learned (via a socket event or an explicit user
  // action) that the BE badge state changed — otherwise a still-warm cached
  // response from before the mutation will overwrite the just-updated UI
  // counters and the badges will appear "frozen" until the next refresh.
  const getBadgesCount = async (force = false) => {
    if (userLoginToken) {
      const { data } = await getBadgeCount(force ? { force: true } : undefined);
      if (data?.status) {
        await props.updateAllBadgeCount(data);
      }
    }
  };

  // Join the shared badge room and this user's mailbox room. Runs on every
  // socket connect: a reconnect (network blip, sleep, backend deploy) gets a
  // new server-side socket that is in no room, and used to stay deaf to new
  // mail until a page reload. An expired access token cannot join the
  // mailbox room — refresh it; the token change reconnects the socket, which
  // subscribes again.
  const subscribeToBadgeRoom = (socket) => {
    try {
      socket.emit("get", buildBadgeSubscribeRequest(), (res) => {
        const body = res && (res.body || res);
        if (body && body.userRoom === false) {
          console.warn("[socket] mailbox room not joined:", body.code);
          if (body.code === "TOKEN_EXPIRED") refreshAccessToken();
        }
      });
    } catch (e) {
      console.log("Exception:", e);
    }
  };

  // Anything pushed while the socket was down (or the tab was asleep) was
  // missed: open email lists re-fetch their first page and the counters
  // reload. Throttled — reconnect, focus and "online" often fire together.
  const lastEmailCatchUpRef = useRef(0);
  const socketConnectedOnceRef = useRef(false);
  const requestEmailCatchUp = () => {
    const now = Date.now();
    if (now - lastEmailCatchUpRef.current < 5000) return;
    lastEmailCatchUpRef.current = now;
    dispatch({ type: EMAIL_CATCH_UP, payload: now });
    (async () => {
      try {
        const { data } = await getBadgeCount({ force: true });
        if (data?.status) {
          dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: data });
        }
      } catch (e) { /* ignore */ }
    })();
  };

  // Language context value - supports both new (language) and legacy (isGerm) patterns
  // Get current language strings object
  const strings = stringsFor(language);

  // Microsoft Teams: the user's IT approved Kjuup (socket 'teamsAccount', action 'consent_granted').
  // The Teams settings page updates itself; any other page gets a toast.
  useEffect(() => {
    const onAccount = (e) => {
      const detail = e && e.detail;
      if (!detail || detail.action !== "consent_granted") return;
      if (window.location.pathname === "/profile-setting" && window.location.search.indexOf("section=teams") !== -1) return;
      $crud.notify({
        type: "success",
        message: teamsText(strings, "teams_consent_granted_toast", "Your IT approved Kjuup for Microsoft Teams. Connect your account in Settings → Microsoft Teams."),
      });
    };
    window.addEventListener(TEAMS_ACCOUNT_EVENT, onAccount);
    return () => window.removeEventListener(TEAMS_ACCOUNT_EVENT, onAccount);
  }, [strings]);

  // Keep branch/role label localization in sync with the active UI language
  // so convertBranchRole / CompanyRoles can resolve all 34 languages.
  useEffect(() => {
    setCurrentBranchLang(language);
  }, [language]);
  
  const lgVal = { 
    isGerm, 
    setIsGerm: (val) => {
      setIsGerm(val);
      setLanguage(val ? 'de' : 'en');
    },
    language,
    setLanguage: (lang) => {
      setLanguage(lang);
      const germanFamily = lang === 'de' || lang === 'gsw' || lang === 'wae';
      setIsGerm(germanFamily);
      localStorage.setItem('switch', germanFamily ? '2' : '1');
      localStorage.setItem('language', lang);
    },
    // Current language strings - use this instead of isGerm ? DE.key : EN.key
    strings,
    // Helper function to get translation
    t: (key) => strings[key] || EN[key] || key
  };
  useEffect(() => {
    var userLang = navigator.language || navigator.userLanguage;
    if (!localStorage.getItem("switch")) {
      if (userLang === "de") {
        localStorage.setItem("switch", "2");
        localStorage.setItem("language", "de");
        setIsGerm(true);
        setLanguage('de');
      } else {
        localStorage.setItem("switch", "1");
        localStorage.setItem("language", "en");
        setIsGerm(false);
        setLanguage('en');
      }
    }
  }, []);

  const _removeSocket = async () => {
    await localStorage.removeItem("socketID");
  };
  const cleanupSocket = () => {
    const current = socketRef.current || Socket;
    socketRef.current = null;
    try {
      if (current) {
        if (typeof current.off === 'function') current.off();
        if (typeof current.offAny === 'function') current.offAny();
        if (typeof current.removeAllListeners === 'function') current.removeAllListeners();
        if (typeof current.disconnect === 'function') current.disconnect();
        if (typeof current.close === 'function') current.close();
      }
    } catch (e) {
      console.log("Socket cleanup error:", e);
    } finally {
      setSocket(null);
    }
  };

  useEffect(() => {
    user ? setIsLoggedIn(true) : setIsLoggedIn(false)
  }, [user]);

  useEffect(() => {
    const fullUrl = window.location.href;
    const params = new URLSearchParams(window.location.search);
    let impersonateToken = params.get('impersonate_token');
    let impersonateCode = params.get('impersonate_code');
    try {
      if (!impersonateToken) impersonateToken = sessionStorage.getItem('kjuup_impersonate_token');
      if (!impersonateCode) impersonateCode = sessionStorage.getItem('kjuup_impersonate_code');
    } catch (e) {}

    if (!impersonateToken && !impersonateCode) return;

    console.log('[Impersonate] Full URL:', fullUrl);
    console.log('[Impersonate] Token present:', Boolean(impersonateToken), 'Code present:', Boolean(impersonateCode));

    try {
      if (impersonateCode) sessionStorage.setItem('kjuup_impersonate_code', impersonateCode);
      if (impersonateToken) sessionStorage.setItem('kjuup_impersonate_token', impersonateToken);
    } catch (e) {}

    // Strip credentials from the address bar before any await so they aren't
    // visible to the user or leaked via referrer headers.
    window.history.replaceState({}, '', '/');
    setIsImpersonating(true);
    setSuppressUnauthorized(true);
    dispatch({ type: SET_IS_UNAUTHORIZED, status: false });

    // User-facing copy keyed by failure reason. Mirrors the catalog in
    // mobile's ImpersonationService so wording stays consistent across
    // surfaces.
    const ERROR_COPY = {
      expired: {
        title: 'This sign-in link has expired',
        description:
          'For security, sign-in links are valid for one hour. Please ask the administrator to generate a new link from the Admin Panel.',
      },
      invalid: {
        title: 'This sign-in link is no longer valid',
        description:
          'The link may have been revoked or never existed. Please ask the administrator to generate a new link from the Admin Panel.',
      },
      network: {
        title: 'Connection problem',
        description:
          "We couldn't reach Kjuup to verify your sign-in link. Please check your internet connection and try the link again.",
      },
      unknown: {
        title: "We couldn't sign you in",
        description:
          'Something went wrong while signing you in. Please try the link again, or ask the administrator for a new one.',
      },
    };

    const showError = (reason) => {
      setSuppressUnauthorized(false);
      const copy = ERROR_COPY[reason] || ERROR_COPY.unknown;
      setImpersonationVariant('error');
      setImpersonationStatus(copy.title);
      setImpersonationSubtext(copy.description);
      // Don't auto-hide: the user dismisses the dialog with the "Got it"
      // button (wired below to setIsImpersonating(false)).
    };

    (async () => {
      // Snapshot the existing session BEFORE we touch anything. If redeem
      // fails (expired link, bad code) we leave the original session intact
      // so the admin doesn't get bounced to /login just for tapping a stale
      // link.
      const previousToken = $user.getToken();

      try {
        // 1. Redeem the short code for a JWT FIRST (1-hour expiry enforced
        //    server-side). Don't clear the existing session until we know
        //    the new credentials are valid.
        let token = impersonateToken;
        if (!token && impersonateCode) {
          setImpersonationStatus('Verifying access link…');
          const resp = await callAPI(`/impersonate/${impersonateCode}`, {}, 'GET');
          const httpStatus = resp?.status;
          const redeemData = resp?.data || {};
          // Impersonation is already a full session. Do not send the admin to
          // the two-factor screen when this account has a second factor on.
          if (!redeemData?.status || !redeemData?.token) {
            // Map HTTP status to a precise reason for the error UI.
            let reason = 'unknown';
            if (httpStatus === 410) reason = 'expired';
            else if (httpStatus === 404) reason = 'invalid';
            else if (!httpStatus || httpStatus >= 500) reason = 'network';
            showError(reason);
            return;
          }
          token = redeemData.token;
        }
        if (!token) {
          showError('invalid');
          return;
        }

        // 2. Redeem succeeded — now safely tear down the previous session.
        //    Without this the previous user's redux state and cached entities
        //    bleed into the new session and the app momentarily kicks the
        //    user back to the login screen during the transition.
        if (previousToken) {
          setImpersonationStatus('Signing out current account…');
          try {
            await $user.logout();
          } catch (e) {
            console.warn('[Impersonate] Pre-logout cleanup warning:', e);
          }
          cleanupSocket();
          dispatch({ type: SET_USER_LOGIN_TOKEN, status: null });
          dispatch({ type: CLEAR_SUBSCRIPTION });
        }

        // 3. Apply the new session in the same order normal login does, so
        //    socket reconnect / badge fetch / language sync all fire correctly.
        setImpersonationStatus('Signing you in…');
        // Drop any prior refresh token so the impersonation access token is
        // exchanged via the legacy-upgrade path into its own fresh pair.
        try { $user.removeRefreshToken(); } catch (_) {}
        $user.setToken(token);
        dispatch({ type: SET_USER_LOGIN_TOKEN, status: token });
        try { await refreshAccessToken(); } catch (_) {}

        // 4. Load profile before tearing the overlay down, so the home screen
        //    paints with the correct user on first frame.
        setImpersonationStatus('Loading profile…');
        const profileResp = await callAPI('/user/profile', {}, 'GET');
        const data = profileResp?.data || profileResp;
        if (!data?.status || !data?.profile) {
          showError('unknown');
          return;
        }
        await $user.set({
          user: data.profile,
          badge: { unseenNewsCount: 0, unseenBuildingChatCount: 0, unseenChatCount: 0 },
        });
        try {
          sessionStorage.removeItem('kjuup_impersonate_code');
          sessionStorage.removeItem('kjuup_impersonate_token');
        } catch (e) {}
        setSuppressUnauthorized(false);
        setIsLoggedIn(true);
        setImpersonationStatus('Welcome back');
        // Tiny linger so the success state is perceptible and the home screen
        // has a frame to mount before the overlay fades.
        setTimeout(() => setIsImpersonating(false), 250);
      } catch (err) {
        console.error('[Impersonate] Error:', err);
        setSuppressUnauthorized(false);
        // Restore the original session if we had one (failure should never
        // log the admin out of their own account just for tapping a stale
        // or expired link).
        if (previousToken && $user.getToken() !== previousToken) {
          try { $user.setToken(previousToken); } catch (_) {}
        }
        showError(err && err.message === 'Network Error' ? 'network' : 'unknown');
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (resetSocket) {
      cleanupSocket();
      dispatch({ type: RESET_SOCKET, payload: false });
    }
  }, [resetSocket]);

  const _getRuuningCalls = async () => {
    const { data } = await callAPI("/videochat/getRunningCalls", {}, "GET");
    const calls = data?.data || data;
    if (calls && calls?.length > 0) {
      dispatch({ type: SET_RUNNING_CALLS, payload: calls })
    }
  };

  useEffect(() => {
    if (updateCalls) {
      if (updateCalls.type === 'videoCallStarted') {
        let res = updateCalls.res
        let users = res.user ? res.user : []
        let isExist = users.find(e => e === user.id)
        if (isExist) {
          let newRunningCalls = [...runningCalls]
          if (newRunningCalls.length > 0) {
            let isFind = newRunningCalls.find(e => e.groupId === res?.groupId)
            if (!isFind) {
              newRunningCalls.push(res)
            }
          }
          else {
            newRunningCalls.push(res)
          }
          dispatch({ type: SET_RUNNING_CALLS, payload: newRunningCalls })
          // Don't flash the ongoing-calls popup for the user who just started
          // (or joined) this call — they've been taken straight into the Jitsi
          // call tab. The `videoCallStarted` socket event is broadcast to every
          // group member including the caller, so without this guard the caller
          // would briefly see the "Anruf gestartet" join banner. The call tab
          // records the room in localStorage (see utils/callTab.js).
          if (newRunningCalls.length > 0 && !isCallActiveForMe(res?.groupId)) {
            dispatch({ type: SHOW_LIST_ONGOING, payload: true })
          }
          setUpdateCalls(false)
        }
      }
      else {
        let res = updateCalls.res
        let users = res.user ? res.user : []
        let isExist = users.find(e => e === user.id)
        if (isExist) {
          let newRunningCalls = runningCalls.filter(e => e.groupId !== res.groupId);
          dispatch({ type: SET_RUNNING_CALLS, payload: newRunningCalls })
          if (newRunningCalls.length == 0) {
            dispatch({ type: SHOW_LIST_ONGOING, payload: false })
          }
          setUpdateCalls(false)
        }
      }
    }
  }, [updateCalls])

  const connectWithSocket = async (loginToken, firetoken) => {
    cleanupSocket();
    console.log("-----> Socket", loginToken, firetoken);
    // Sails sockets must connect to an ABSOLUTE backend URL. On prod
    // `API_ROOT` is already absolute (e.g. https://app.kjuup.de) so we
    // use it directly. On localhost dev `API_ROOT` is the relative
    // string "/api" — passing that to socket.io makes it try to upgrade
    // the WebSocket at the CRA dev origin (ws://localhost:3000/?...),
    // which the CRA dev server cannot serve. The `setupProxy.js` HTTP
    // proxy doesn't fix this either: socket.io's path resolution drops
    // the "/api" prefix when it parses a leading-slash arg as a
    // namespace, so the WS upgrade lands on "/" instead of
    // "/api/socket.io/" and fails. Connecting straight to the BE
    // bypasses the proxy entirely; CORS already allow-lists
    // http://localhost:3000 in `config/security.js`, so the BE accepts
    // the cross-origin handshake.
    //
    // CRITICAL: in dev this MUST target the SAME backend that
    // `setupProxy.js` proxies `/api` to. The only place a chat-open marks
    // messages/images/reactions as read is the socket handler
    // `subscribeToGroupChat` (req.isSocket-only). If the socket lands on a
    // different backend than the one serving `/badge/count` (HTTP, via the
    // proxy), the receipts are flipped on the wrong DB and the unread
    // counters never clear. Keep `REACT_APP_SOCKET_URL` (or this fallback)
    // in sync with the `target` in `src/setupProxy.js`.
    const isAbsoluteApiRoot = typeof API_ROOT === "string" && /^https?:\/\//i.test(API_ROOT);
    const devSocketBase = appConfig.SOCKET_URL;
    const socketBase = isAbsoluteApiRoot ? API_ROOT : devSocketBase;
    let SocketObject = socketio(`${socketBase}/?__sails_io_sdk_version=0.12.14`, {
      jsonp: false,
      parser: customParser,
      transports: ["websocket"],
      autoConnect: true,
      reconnection: true,
      headers: {
        token: loginToken,
        fcmId: firetoken,
      },
      extraHeaders: {
        token: loginToken,
        fcmId: firetoken,
      },
      auth: {
        token: loginToken,
        fcmId: firetoken,
      },
    });
    socketRef.current = SocketObject;
    SocketObject.on("connect", () => {
      SocketObject.off("news").on("news", (data) => {
        if (data.user === user?.id) {
          let count = props.unseenNewsCount;
          if (data.action === "increase") {
            count = count + 1;
            props.updateNewsCount(count);
          }
          if (data.action === "decrease") {
            // count = count - 1;
            // props.updateNewsCount(count);
          }
        }
      });
      // A new article was published (or a scheduled one went live). Moves the
      // Home / feed counters right away instead of waiting for the next
      // /badge/count poll.
      //
      // `users` is an explicit recipient list for internal articles; the
      // external feed is global and sends null, so every client bumps and drops
      // the event when it is the author.
      SocketObject.off("articleBadge").on("articleBadge", (data) => {
        try {
          // Resolved per event, with a localStorage fallback: these listeners are
          // registered once on connect, so relying only on the captured `user`
          // would drop every event when the socket connects before the redux
          // user lands.
          const myId = user?.id || $user.get()?.id;
          if (!data || !myId) return;
          if (data.authorId && String(data.authorId) === String(myId)) return;
          if (Array.isArray(data.users) && !data.users.some((id) => String(id) === String(myId))) return;

          if (data.action === "reset") {
            // Another device of mine opened this feed.
            dispatch({ type: ARTICLE_FEED_SEEN, feedType: data.feedType, company: data.company });
            return;
          }
          dispatch({ type: ARTICLE_BADGE_BUMP, feedType: data.feedType, company: data.company });
          // Lets an open feed show its "N new articles" pill.
          window.dispatchEvent(new CustomEvent("kjuup:new-article", {
            detail: {
              feedType: Number(data.feedType) === 1 ? 1 : 0,
              company: data.company || null,
              articleId: data.articleId || null,
            },
          }));
        } catch (e) { /* ignore */ }
      });
      SocketObject.off("latestMsg").on("latestMsg", async function (data) {
        console.log("-----> Socket", data);
        dispatch({ type: IS_NEW_MESSAGE, status: data });
        // Keep the getChat paint-cache in sync even when the thread is not
        // open (created is only broadcast to the group room). Otherwise the
        // list preview updates and the cached thread stays one message behind.
        try {
          const groupId = data?.group?.id || data?.groupId;
          if (groupId && data?.id) {
            const lang = (localStorage.getItem("language") || "en").split("-")[0].toLowerCase();
            appendCachedMessage(groupId, { ...data, groupId }, lang);
          }
        } catch (e) { /* ignore */ }
        // `latestMsg` always fires when a new chat hits a group room,
        // including for users currently online elsewhere — whereas the
        // `chat` / `building` badge events are scoped to offline users
        // only. We piggyback a forced badge refresh here so the sidebar
        // / tab counters update instantly even if the badge event was
        // suppressed (e.g. a stale LiveChatUsers row makes the BE think
        // the recipient is "in chat" when they aren't). Only fire when
        // the recipient actually has unread chats for this message; the
        // BE includes them in `data.unseenChatCount[]` only in that
        // case, so this avoids needless /badge/count traffic when the
        // current user is just observing their own outgoing message.
        try {
          const recipients = Array.isArray(data?.unseenChatCount) ? data.unseenChatCount : [];
          const myId = user?.id || $user.get()?.id;
          const isForMe = recipients.some((e) => String(e?.userId) === String(myId));
          if (isForMe) {
            getBadgesCount(true);
          }
          notifyChatIfBackground(data, myId, openChatFromPush);
        } catch (e) { /* ignore */ }
      });
      SocketObject.off("groupMemberAdded").on("groupMemberAdded", function (data) {
        if (data.userId === user?.id) {
          dispatch({ type: RESET_LATEST_MESSAGES, status: true });
        }
      });
      SocketObject.off("chat").on("chat", (res) => {
        console.log("-----> Socket chat", res);
        setIsChatCount(res);
      });
      SocketObject.off("dailyBriefing").on("dailyBriefing", (res) => {
        try {
          if (res?.user === user?.id && res?.action === "increase") {
            if (shouldShowDailyBriefingCounters(user, profile, subscriptionState)) {
              if (res?.buildingId) {
                dispatch({ type: INCREMENT_UNSEEN_DAILY_BRIEFING_COUNT, buildingId: res.buildingId });
              } else {
                dispatch({ type: INCREMENT_UNSEEN_ALL_SCOPE_DAILY_BRIEFING_COUNT });
              }
            }
            const title = res.subject || "Daily report";
            const body = res.snippet || "A new report is ready";
            notifyIfBackground({ title, body, tag: "kjuup-briefing", icon: "/assets/img/logo.png" });
            getBadgesCount(true);
          }
        } catch (e) { /* ignore */ }
      });
      SocketObject.off("todoAssigned").on("todoAssigned", (res) => {
        try {
          if (res?.userId === user?.id) {
            // Instant badge bump + list-refresh trigger, then reconcile with BE truth
            dispatch({ type: INCREMENT_UNSEEN_TODO_COUNT });
            getBadgesCount(true);
            // Open tabs must show the OS banner themselves: the service worker
            // swallows backend Web Push while a Kjuup tab is open (keepalive
            // only). Email / daily briefing already do this via notifyIfBackground.
            const todoNotifOn = !!(user?.todoNotificationEnabled || $user.get()?.todoNotificationEnabled);
            if (todoNotifOn) {
              const lang = (localStorage.getItem("language") || "en").split("-")[0].toLowerCase();
              const loc = LANGUAGE_MAP[lang] || EN;
              const desc = String(res.description || "").trim();
              const prefix = loc.todo_assigned_push || EN.todo_assigned_push;
              const body = desc
                ? `${prefix} ${desc}`
                : (loc.todo_assigned_push_empty || EN.todo_assigned_push_empty);
              notifyIfBackground({
                title: "Kjuup",
                body,
                tag: res.todoId ? `todo-assign:${res.todoId}` : "kjuup-todo",
                icon: "/assets/img/logo.png",
                data: { model: "todo", id: res.todoId || "", buildingId: res.buildingId || "" },
                onClick: () => openTodoFromPush({ todoId: res.todoId, buildingId: res.buildingId }),
              });
            }
          }
        } catch (e) { /* ignore */ }
      });
      SocketObject.off("todoUpdated").on("todoUpdated", (res) => {
        try {
          if (res?.userId === user?.id || res?.todoId) {
            dispatch({ type: REFRESH_TODO_LIST });
          }
        } catch (e) { /* ignore */ }
      });
      SocketObject.off("todoCalendarSync").on("todoCalendarSync", (res) => {
        try {
          if (res?.userId === user?.id) {
            if (res.action === "deleted" && res.todoId) {
              dispatch({ type: TODO_CALENDAR_DELETED, todoId: res.todoId });
            } else if (res.action === "removed_from_calendar" && res.todoId) {
              // Deleted in the calendar: the ToDo stays, its calendar button turns off.
              dispatch({ type: TODO_CALENDAR_REMOVED, todoId: res.todoId });
            } else {
              dispatch({ type: REFRESH_TODO_LIST });
            }
            getBadgesCount(true);
          }
        } catch (e) { /* ignore */ }
      });
      SocketObject.off("emojiBadge").on("emojiBadge", (res) => {
        // Someone reacted to one of my messages. Treat it like an unread
        // message: bump that chat's badge in the list and refresh the
        // global /badge/count so the sidebar counter updates in real time.
        try {
          const isForMe = Array.isArray(res?.user) && res.user.some((id) => id === user?.id);
          if (!isForMe || !res?.group) return;
          dispatch({ type: BUMP_CHAT_REACTION, groupId: res.group, chatId: res.chatId, emoji: res.emoji, reactorName: res.reactorName });
          getBadgesCount(true);
        } catch (e) { /* ignore */ }
      });
      SocketObject.off("building").on("building", (res) => {
        if (res && res.requestId) {
          dispatch({ type: FETCH_ALL_REQUEST, status: true })
        }
        console.log("-----> Socket Building", res);
        setIsChatCountProjects(res);
      });
      SocketObject.off("videoCallStarted").on("videoCallStarted", (res) => {
        console.log("-----> InComming Call", res);
        setUpdateCalls({ type: 'videoCallStarted', res: res })
      });
      SocketObject.off("videoCallEnded").on("videoCallEnded", (res) => {
        console.log("-----> InComming in ended", res);
        setUpdateCalls({ type: 'videoCallEnded', res: res })
      });
      SocketObject.off("unreadChatCount").on("unreadChatCount", async (res) => {
        // Microsoft Teams read marker advanced (sent to the owner only): the Messages row takes the
        // remaining count, without reordering. The badge recount below still runs.
        if (res?.source === "teams" && res.group != null) {
          const myId = user?.id || $user.get()?.id;
          const mine = Array.isArray(res.user) ? res.user.some((u) => String(u) === String(myId)) : String(res.user) === String(myId);
          if (mine) {
            try {
              window.dispatchEvent(new CustomEvent(TEAMS_UNREAD_EVENT, {
                detail: { group: res.group, unreadCount: Number(res.unreadChatCount ?? res.count) || 0 },
              }));
            } catch (e) { /* ignore */ }
          }
        }
        if (res?.building) {
          setIsChatCountProjects(res);
        } else {
          setIsChatCount(res);
        }
      });
      SocketObject.off("email").on("email", (res) => {
        console.log("-----> Socket email sync", res);
        // Same per-event id lookup as articleBadge: the captured `user` can
        // be stale, and ids are compared as strings.
        const myId = user?.id || $user.get()?.id;
        if (res && myId && String(res.user) === String(myId)) {
          dispatch({ type: EMAIL_SYNC, payload: res });
          if (res.action === "increase") {
            allowBadgeIncreases();
            const liveUser = $user.get() || user || {};
            const emailPushOn = liveUser.emailPushNotificationEnabled !== false;
            const msgs = Array.isArray(res.messages) ? res.messages : [];
            const unread = msgs.filter((m) => m && !m.isRead && m.direction !== "outgoing");
            if (emailPushOn && unread.length) {
              const pick = unread[unread.length - 1];
              const title = emailPushSender(pick, res.email || "New Email");
              const body = emailPushSummary(pick)
                || (unread.length === 1
                  ? "You have a new email"
                  : `You have ${unread.length} new emails`);
              notifyIfBackground({
                title,
                body,
                tag: pick?.providerMessageId
                  ? `kjuup-email:${res.accountId || ""}:${pick.providerMessageId}`
                  : (pick?.id ? `kjuup-email:${pick.id}` : "kjuup-email"),
                icon: "/assets/img/logo.png",
                dedupeMs: 120000,
              });
            }
          }
          (async () => {
            try {
              // `force: true` bypasses the post-flight reuse cache. The
              // socket event tells us the BE just inserted/deleted/
              // re-flagged messages, so a still-warm cached badge
              // response from before this event would overwrite the
              // EMAIL_SYNC increment we just dispatched and the counter
              // would visibly "fail to update on new emails".
              const { data } = await getBadgeCount({ force: true });
              if (data?.status) {
                dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: data });
              }
            } catch (e) { /* ignore */ }
          })();
        }
      });
      // Real-time multi-device email-account sync. When the same user links or
      // unlinks an email account on another device, the BE broadcasts
      // `emailAccount`; bump a nonce in the store so screens holding a local
      // account list (Latest Messages, Profile Settings) re-fetch live.
      SocketObject.off("emailAccount").on("emailAccount", (res) => {
        const myId = user?.id || $user.get()?.id;
        if (res && myId && String(res.user) === String(myId)) {
          dispatch({ type: EMAIL_ACCOUNTS_CHANGED, payload: Date.now() });
          if (res.action === "unlinked") {
            invalidateBadgeCount();
            (async () => {
              try {
                const { data } = await getBadgeCount({ force: true });
                if (data?.status) {
                  dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: data });
                }
              } catch (e) { /* ignore */ }
            })();
          }
        }
      });
      // My Space pin/unpin: keep the messages list order in sync live
      // (this tab, other tabs, other devices) instead of waiting for the
      // next getUserChats fetch.
      // Microsoft Teams (owner only): 'teamsAccount' import progress → the Teams settings page,
      // 'teamsChatsChanged' → a window event. Removes only its own handlers, so the Messages list's
      // own 'teamsChatsChanged' listener on this socket stays.
      relayTeamsSocketEvents(SocketObject);
      SocketObject.off("chatPinned").on("chatPinned", (res) => {
        try {
          const myId = user?.id || $user.get()?.id;
          if (!res || !myId || String(res.user) !== String(myId)) return;
          dispatch({
            type: MY_SPACE_PINNED,
            groupId: res.group,
            isPinned: !!res.isPinned,
          });
        } catch (e) { /* ignore */ }
      });
      // ToDo counter / push-notification preference changed on another
      // device (mobile settings, second tab, Admin Panel). Same user flag
      // `todoNotificationEnabled` that /user/profile and the toggle read.
      SocketObject.off("todoNotification").on("todoNotification", (res) => {
        try {
          const myId = user?.id || $user.get()?.id;
          if (!res || !myId || String(res.user) !== String(myId)) return;
          const enabled = !!res.todoNotificationEnabled;
          const current = $user.get() || user || {};
          $user.updateUserData({ ...current, todoNotificationEnabled: enabled });
          getBadgesCount(true);
        } catch (e) { /* ignore */ }
      });
      SocketObject.off("emailPushNotification").on("emailPushNotification", (res) => {
        try {
          const myId = user?.id || $user.get()?.id;
          if (!res || !myId || String(res.user) !== String(myId)) return;
          const enabled = res.emailPushNotificationEnabled !== false;
          const current = $user.get() || user || {};
          $user.updateUserData({ ...current, emailPushNotificationEnabled: enabled });
        } catch (e) { /* ignore */ }
      });
      // Seamless token rotation: an admin rotated this device's session token.
      // Swap the token in place (localStorage drives every HTTP Authorization
      // header, read per-request) and update the store token. Changing
      // userLoginToken re-runs the socket lifecycle effect, which reconnects the
      // socket with the new token and re-registers the session via isOnline.
      // The user is NOT logged out; the old token is retired server-side after a
      // short grace window.
      SocketObject.off("tokenRotated").on("tokenRotated", (res) => {
        if (!res || !res.token || res.userId !== user?.id) return;
        console.log("-----> Socket tokenRotated: swapping session token");
        try { $user.setToken(res.token); } catch (_) {}
        dispatch({ type: SET_USER_LOGIN_TOKEN, status: res.token });
      });
      // Admin Center toggled Stripe / Kjuup.io (globally, for one Kjuup user,
      // or for a Kjuup+ company). Re-pull entitlement so every gate re-renders
      // and Stripe-only pages redirect, instead of waiting for the next
      // navigation or reload.
      // A global toggle reaches every connected client at once, so the refetch
      // is jittered to avoid a synchronised burst on the BE.
      SocketObject.off("stripeFeatureUpdated").on("stripeFeatureUpdated", (res) => {
        if (!res) return;
        if (res.scope === "company" || res.scope === "user") {
          const affected = Array.isArray(res.users) ? res.users : [];
          if (!user?.id) return;
          if (!affected.some((u) => String(u) === String(user.id))) return;
        }
        setTimeout(() => {
          fetchAndStoreSubscriptionStatus(dispatch);
          // Keeps companies[].isKjuup and the profile-level flags (the fallback
          // before status lands) in sync too.
          getProfile();
        }, Math.floor(Math.random() * 2000));
      });
      // Stripe changed my Kjuup.io subscription (trial ended, charged,
      // canceled, admin expiry). Refetch so the trial countdown and gates
      // settle on the server's state right away.
      SocketObject.off("kjuupIoStatusUpdated").on("kjuupIoStatusUpdated", (res) => {
        const affected = Array.isArray(res?.userIds) ? res.userIds : [];
        if (!user?.id || !affected.some((u) => String(u) === String(user.id))) return;
        fetchAndStoreSubscriptionStatus(dispatch);
      });
      setSocket(SocketObject);
      setUserOnline(SocketObject);
      subscribeToBadgeRoom(SocketObject);
      // Every connect after the first one of this page: a reconnect, or the
      // new socket after a token refresh (hourly), was deaf for a moment.
      if (socketConnectedOnceRef.current) requestEmailCatchUp();
      socketConnectedOnceRef.current = true;
    });
  };

  const _getLatestChat = async () => {
    const { data } = await callAPI("/group", {}, "GET");
    if (data.status) {
      const updateData = data.groups.map((building, i) => {
        return {
          ...building,
          key: i + 1,
          isOpened: !![...props.openChats, ...props.openBottomChats].find(
            (g) => g.id === building.id
          ),
          originalMessage: building.lastMessage,
          messageLng: "en",
          isBlock: building.name.trim()
            ? !!building.users.find((u) => u.id !== user?.id)?.isBlock
            : false,
        };
      });
      dispatch({ type: GROUPS, groups: updateData });
    }
  };

  const _getLatestGroup = async () => {
    if (userLoginToken) {
      const { data } = await callAPI("/building/my", {}, "GET");
      if (data.status) {
        const sortData = await _.sortBy(data.buildings, [
          (comp) => {
            return comp.updatedAt && !comp.isJoin;
          },
        ]);
        const newData = await sortData?.map((building, i) => {
          return {
            ...building,
            key: i + 1,
            isOpened: !!(openProjects || []).find(
              (g) => g?.id === building?.id
            ),
          };
        });
        dispatch({ type: PROJECTS, projects: newData });
      }
    }
  };

  const getChats = async (projectInfo) => {
    if (projectInfo?.id && projectInfo.id != undefined && projectInfo.id != 'undefined') {
      const { data } = await callAPI(
        `/building/${projectInfo?.id}/chat`,
        {
          userId: user?.id,
          lang: isGerm ? "de" : "en",
        },
        "GET"
      );
      if (data.status) {
        let chatsData = await Promise.all(
          data.groups.map(async (chat) => {
            return {
              ...chat,
              isOpened: false,
              // isLeave: await checkExist(chat.users),
            };
          })
        );

        let chatGroupUsers = [];
        if (projectInfo?.viewByOwner) {
          chatGroupUsers = chatsData.map((group) => {
            if (
              group.isLeave === true &&
              group.users.find((u) => u.id === (projectInfo.ownerId ?? user?.id))
            ) {
              group.disabled = true;
            } else {
              group.disabled = false;
            }
            return group;
          });
        } else {
          chatGroupUsers = chatsData?.map((group) => {
            if (
              group.isLeave === true &&
              group.users.find((u) => u.id === (projectInfo.ownerId ?? user?.id))
            ) {
              return {
                ...group,
                isOpened: !!groupChats.find((g) => g.id === group.id),
                disabled: true,
              };
            } else {
              return {
                ...group,
                isOpened: !!groupChats.find((g) => g.id === group.id),
                disabled: false,
              };
            }
          });
        }
        let userData = JSON.parse(localStorage.getItem("user"));
        let filterData = chatGroupUsers
          .sort((a, b) => (a.isLeave === true) - (b.isLeave === true))
          .filter((item) => {
            if (item.isArchived) return false;
            if (!projectInfo?.viewByOwner)
              return item.users.find((it) => it.id === userData.id) && item;
            else
              return (
                item.users.find((it) => it.id === projectInfo.ownerId) && item
              );
          });
        dispatch({
          type: SET_ALLGROUPS_PROJECTS,
          payload: {
            projectId: projectInfo?.id,
            newGroups: _sortArray([...filterData]),
          },
        });
      }
    }
  };

  const _sortArray = (res) => {
    let _temp = [...res];
    let _joined = [];
    let _leaved = [];
    for (let obj of _temp) {
      let chatUser = obj.users.filter((u) => u.id == user.id);
      if (chatUser?.length > 0) {
        if (!chatUser[0]?.isLeave) {
          _joined.push(obj);
        } else {
          _leaved.push(obj);
        }
      } else {
        _leaved.push(obj);
      }
    }
    return _joined
      .sort((a, b) => {
        return b.defaultChatGroup - a.defaultChatGroup;
      })
      .concat(_leaved);
  };

  const getKjuupPlusProjects = async () => {
    const { data } = await callAPI("/building/internalProjects", {}, "GET");
    if (data.status) {
      let all = [...data.foundUserCompany];
      if (all.length > 0) {
        let leaved = all.filter((e) => e.isLeave);
        let joined = all.filter((e) => !e.isLeave);
        let _all = [...joined, ...leaved];
        let filteredArticles = _all.map((e, i) => {
          if (selectedCompanyId !== null)
            return { ...e, isSelected: e.id === selectedCompanyId };
          else return { ...e, isSelected: i === 0 };
        });
        dispatch({ type: INTERNAL_PROJECTS, projects: filteredArticles });
      }
    }
  };

  // Skips the mount run so we don't duplicate the fetch the login-token effect
  // already does; only real tab re-focuses should re-pull entitlement.
  const didMountVisibilityRef = useRef(false);
  useEffect(() => {
    if (isImpersonating) return;
    if (isVisible) {
      setUserOnline(Socket);
      // A backgrounded tab can miss the stripeFeatureUpdated broadcast (socket
      // dropped, machine asleep), so re-pull entitlement when it comes back.
      if (didMountVisibilityRef.current && $user.getToken()) {
        fetchAndStoreSubscriptionStatus(dispatch);
        requestEmailCatchUp();
      }
      didMountVisibilityRef.current = true;
    } else {
      _setUserOffline(Socket);
    }
  }, [isVisible, isImpersonating]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    // Back online: the socket reconnects on its own (and catches up then);
    // this covers a socket that never noticed it was offline.
    const handleOnline = () => {
      if ($user.getToken()) requestEmailCatchUp();
    };
    window.addEventListener("online", handleOnline);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  useEffect(() => {
    if (isChatCount) {
      let userDetails = localStorage.getItem("user");
      if (userDetails) {
        const isFind = isChatCount.user.find((item) => item === user.id);
        if (isFind) {
          if (isChatCount.action === "increase") {
            allowBadgeIncreases();
            if (isChatCount.markUnread) {
              getBadgesCount(true);
              setIsChatCount(false);
              return;
            }
            let a = { ...unSeenAllCount };
            let baseChat = Number.isFinite(a.unseenChatCount) ? a.unseenChatCount : 0;
            let f = { ...a, unseenChatCount: baseChat + 1 };
            let tmp = [...groups];
            for (let obj of tmp) {
              if (obj.id === isChatCount.group) {
                let cnt = obj.unseenChatCount;
                obj.unseenChatCount = cnt + 1;
              }
            }
            dispatch({ type: GROUPS, groups: tmp });
            props.updateAllBadgeCount(f);
            // Confirm the badge with a fresh BE fetch. The local +1 above
            // is for instant UI feedback, but we still reconcile against
            // /badge/count to catch the case where `unSeenAllCount` was
            // stale (e.g. another component just dispatched a partial
            // update) and to make sure the sidebar / tab counters match
            // the BE truth without requiring a page reload. `force: true`
            // bypasses the post-flight cache so we don't get a snapshot
            // taken before this message landed in the DB.
            getBadgesCount(true);
          }
          if (isChatCount.action === "decrease") {
            getBadgesCount(true);
          }
        }
        _getLatestChat();
      }
      setIsChatCount(false);
    }
  }, [isChatCount]);

  useEffect(() => {
    if (isChatCountProjects) {
      let userDetails = localStorage.getItem("user");
      if (userDetails) {
        const isFind = isChatCountProjects.user.find(
          (item) => item === user.id
        );
        if (isFind) {
          // Only increment unseen counts for messages, NOT for room invitations
          // Room invitations are handled separately via joinRequestsExternal/Internal arrays
          if (isChatCountProjects.action === "increase" && !isChatCountProjects?.requestId) {
            allowBadgeIncreases();
            if (isChatCountProjects.markUnread) {
              getBadgesCount(true);
              setIsChatCountProjects(false);
              return;
            }
            let a = { ...unSeenAllCount };
            const baseInternal = Number.isFinite(a.unseenInternalProject) ? a.unseenInternalProject : 0;
            const baseExternal = Number.isFinite(a.unseenExternalProject) ? a.unseenExternalProject : 0;
            let f = isChatCountProjects.isInternal ? {
              ...a,
              unseenInternalProject: baseInternal + 1,
            } :
              {
                ...a,
                unseenExternalProject: baseExternal + 1,
              }
            props.updateAllBadgeCount(f);
            // Reconcile with the BE truth (see chat-increase handler above
            // for the rationale — same race / staleness guard).
            getBadgesCount(true);
          }
          if (isChatCountProjects?.requestId) {
            const requestId = isChatCountProjects.requestId;
            const companyId = isChatCountProjects.company_id;

            if (isChatCountProjects.action === "descrease") {
              const filteredExternal = joinRequestsExternal.filter(req => req.requestId !== requestId);
              const removedFromExternal = filteredExternal.length !== joinRequestsExternal.length;
              if (removedFromExternal) {
                dispatch({ type: SET_JOIN_REQUEST_EXTERNAL, requests: filteredExternal });
              }

              let tmp = [...internalProjectsAll];
              let removedFromInternal = false;
              tmp = tmp.map(company => {
                if (company.projectJoinRequests) {
                  const filtered = company.projectJoinRequests.filter(req => req.requestId !== requestId);
                  if (filtered.length !== company.projectJoinRequests.length) {
                    removedFromInternal = true;
                    return { ...company, projectJoinRequests: filtered };
                  }
                }
                return company;
              });
              if (removedFromInternal) {
                dispatch({ type: INTERNAL_PROJECTS, projects: tmp });
                const reqMap = new Map();
                tmp.forEach(company => {
                  if (company.projectJoinRequests && company.projectJoinRequests.length > 0) {
                    company.projectJoinRequests.forEach(req => {
                      if (req.requestId && !reqMap.has(req.requestId)) {
                        reqMap.set(req.requestId, req);
                      }
                    });
                  }
                });
                dispatch({ type: SET_JOIN_REQUEST_INTERNAL, requests: Array.from(reqMap.values()) });
              }

              let updatedCounts = { ...unSeenAllCount };
              if (removedFromExternal) {
                updatedCounts.unseenExternalProject = Math.max(0, (updatedCounts.unseenExternalProject || 0) - 1);
              }
              if (removedFromInternal) {
                updatedCounts.unseenInternalProject = Math.max(0, (updatedCounts.unseenInternalProject || 0) - 1);
              }
              if (removedFromExternal || removedFromInternal) {
                props.updateAllBadgeCount(updatedCounts);
              }
              getBadgesCount(true);
            } else {
            
            // Determine if this is an external or internal request
            const isExternalRequest = !companyId || 
                                     companyId === "undefined" || 
                                     companyId === "null" ||
                                     companyId === undefined ||
                                     companyId === null;
            
            if (isExternalRequest) {
              // Remove from internal arrays if it exists there
              let tmp = [...internalProjectsAll];
              let removedFromInternal = false;
              
              tmp = tmp.map(company => {
                if (company.projectJoinRequests) {
                  const filtered = company.projectJoinRequests.filter(req => req.requestId !== requestId);
                  if (filtered.length !== company.projectJoinRequests.length) {
                    removedFromInternal = true;
                    return { ...company, projectJoinRequests: filtered };
                  }
                }
                return company;
              });
              
              if (removedFromInternal) {
                dispatch({ type: INTERNAL_PROJECTS, projects: tmp });
                // Aggregate with deduplication
                const requestMap = new Map();
                tmp.forEach(company => {
                  if (company.projectJoinRequests && company.projectJoinRequests.length > 0) {
                    company.projectJoinRequests.forEach(req => {
                      if (req.requestId && !requestMap.has(req.requestId)) {
                        requestMap.set(req.requestId, req);
                      }
                    });
                  }
                });
                const allInternalRequests = Array.from(requestMap.values());
                dispatch({ type: SET_JOIN_REQUEST_INTERNAL, requests: allInternalRequests });
              }
              
              // Add to external array only if it doesn't already exist, and deduplicate the entire array
              const existsInExternal = joinRequestsExternal.some(req => req.requestId === requestId);
              if (!existsInExternal) {
                const newRequests = [...joinRequestsExternal, { ...isChatCountProjects }];
                // Deduplicate the entire array by requestId
                const requestMap = new Map();
                newRequests.forEach(req => {
                  if (req?.requestId && !requestMap.has(req.requestId)) {
                    requestMap.set(req.requestId, req);
                  }
                });
                const uniqueRequests = Array.from(requestMap.values());
                dispatch({
                  type: SET_JOIN_REQUEST_EXTERNAL,
                  requests: uniqueRequests,
                });
              }
            } else {
              // Remove from external array if it exists there
              const filteredExternal = joinRequestsExternal.filter(req => req.requestId !== requestId);
              if (filteredExternal.length !== joinRequestsExternal.length) {
                // Deduplicate the filtered array before dispatching
                const requestMap = new Map();
                filteredExternal.forEach(req => {
                  if (req?.requestId && !requestMap.has(req.requestId)) {
                    requestMap.set(req.requestId, req);
                  }
                });
                const uniqueRequests = Array.from(requestMap.values());
                dispatch({
                  type: SET_JOIN_REQUEST_EXTERNAL,
                  requests: uniqueRequests,
                });
              }
              
              // Add to internal array
              let tmp = [...internalProjectsAll];
              let ind = tmp.findIndex(
                (e) => e.id == companyId
              );
              if (ind !== -1) {
                // Check if request already exists in this company's requests
                const existingRequest = tmp[ind].projectJoinRequests?.find(req => req.requestId === requestId);
                
                if (!existingRequest) {
                  tmp[ind].totalUnreadChat =
                    tmp[ind].totalUnreadChat || tmp[ind].totalUnreadChat == 0
                      ? tmp[ind].totalUnreadChat + 1
                      : 1;
                  tmp[ind].projectJoinRequests = tmp[ind].projectJoinRequests
                    ? [
                      ...tmp[ind].projectJoinRequests,
                      { ...isChatCountProjects },
                    ]
                    : [{ ...isChatCountProjects }];
                }
              }
              console.log("------------------>internal request", tmp);
              dispatch({ type: INTERNAL_PROJECTS, projects: [...tmp] });
              
              // Aggregate all internal join requests from all companies and update Redux store
              // Use a Map to deduplicate by requestId
              const requestMap = new Map();
              tmp.forEach(company => {
                if (company.projectJoinRequests && company.projectJoinRequests.length > 0) {
                  company.projectJoinRequests.forEach(req => {
                    if (req.requestId && !requestMap.has(req.requestId)) {
                      requestMap.set(req.requestId, req);
                    }
                  });
                }
              });
              const allInternalRequests = Array.from(requestMap.values());
              dispatch({ type: SET_JOIN_REQUEST_INTERNAL, requests: allInternalRequests });
            }
            }
          } else {
            let isInternal = -1;
            let isExternal = projects.findIndex(
              (e) => e.id == isChatCountProjects.building
            );
            console.log('isChatCountProjects===>ieEx', isExternal)
            if (isChatCountProjects.action === "increase") {
              let TXX = [...internalProjectsAll];
              for (let obj of TXX) {
                if (obj.userProjectList && obj.userProjectList.length > 0) {
                  let ind = obj.userProjectList.findIndex(
                    (e) => e.id == isChatCountProjects.building
                  );
                  if (ind !== -1) {
                    isInternal = 1;
                    obj.totalUnreadChat = obj.totalUnreadChat + 1;
                    obj.userProjectList[ind].unseenBuildingChat =
                      obj.userProjectList[ind].unseenBuildingChat + 1;
                    // Room lists sort by last activity (roomOrder): move it up.
                    obj.userProjectList[ind] = {
                      ...obj.userProjectList[ind],
                      lastActivityAt: new Date().toISOString(),
                    };
                  }
                }
              }
              if (isExternal !== -1) {
                let TXXEXTERNAL = [...projects];
                TXXEXTERNAL[isExternal].unseenBuildingChat =
                  TXXEXTERNAL[isExternal].unseenBuildingChat + 1;
                TXXEXTERNAL[isExternal] = {
                  ...TXXEXTERNAL[isExternal],
                  lastActivityAt: new Date().toISOString(),
                };
                dispatch({ type: PROJECTS, projects: TXXEXTERNAL });
              }
              dispatch({ type: INTERNAL_PROJECTS, projects: TXX });
              let tmp = [...AllGroupsOfProjects];
              let allGrps = tmp.findIndex(
                (e) => e.projectId == isChatCountProjects.building
              );
              if (allGrps !== -1) {
                let currentGroup = [...tmp[allGrps].groups];
                let gIndex = currentGroup.findIndex(
                  (e) => e.id == isChatCountProjects.group
                );
                if (gIndex !== -1) {
                  tmp[allGrps].groups[gIndex].unseenChatCount =
                    tmp[allGrps].groups[gIndex].unseenChatCount + 1;
                  dispatch({
                    type: SET_ALLGROUPS_PROJECTS,
                    payload: {
                      projectId: isChatCountProjects.building,
                      newGroups: tmp[allGrps].groups,
                    },
                  });
                }
              }
            }
            if (isChatCountProjects.action === "decrease") {
              getBadgesCount(true);
              _getLatestGroup();
              getKjuupPlusProjects();
            }
          }
        }
      }
      setIsChatCountProjects(false);
    }
  }, [isChatCountProjects]);

  const setUserOnline = (SocketObject) => {
    let ttn = $user.getToken()
    let onlineObj1 = {
      // SOCKET_BASE (not API_ROOT): socket routes are matched by pathname and
      // must not carry the dev "/api" prefix.
      url: `${SOCKET_BASE}/user/isOnline`,
      method: 'get',
      headers: {
        Authorization: `jwt ${ttn}`
      },
    }
    dispatch({ type: SET_USER_LOGIN_TOKEN, status: ttn })
    if (SocketObject && SocketObject.emit) {
      SocketObject.emit("get", onlineObj1, async (data) => {
        console.log("============+> Socket isOnline", data);
      });
    }
  };

  var interVal;
  // Persisted per tab session so a reload (or a forced navigation elsewhere in
  // the app) does not re-arm the update prompt for a version we already handled.
  const [notifiedVersion, setNotifiedVersion] = useState(() => {
    try { return sessionStorage.getItem('kjuup_notified_version'); } catch (e) { return null; }
  });

  useEffect(() => {
    // Local webpack already compiles in the background; don't auto-reload the tab.
    if (process.env.NODE_ENV === "development") {
      return;
    }
    interVal = setInterval(() => {
      VersionCheckButton()
    }, 600000)
    
    // Cleanup interval on unmount
    return () => {
      if (interVal) {
        clearInterval(interVal);
      }
    };
  }, [])

  const checkCacheStatus = () => {
    return new Promise(async (resolve, reject) => {
      try {
        // Force fetch to bypass cache - always get latest version
        const res = await fetch("/meta.json", {
          cache: 'no-store',
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        });
        const { version: metaVersion } = await res.json();
        const shouldForceRefresh = isThereNewVersion(metaVersion, version);
        if (shouldForceRefresh) {
          resolve({ isNew: true, metaVersion });
        } else {
          resolve({ isNew: false, metaVersion });
        }
      } catch (error) {
        console.log('An error occurred while checking cache status:', error);
        resolve({ isNew: false, metaVersion: null });
      }
    });
  }

  var isThereNewVersion = function isThereNewVersion(metaVersion, currentVersion) {
    return compare(metaVersion, currentVersion, '>');
  };

  const VersionCheckButton = async () => {
    try {
      let result = await checkCacheStatus();
      // Only show notification if:
      // 1. There's a new version
      // 2. We haven't already notified about this specific version
      if (result.isNew && result.metaVersion && result.metaVersion !== notifiedVersion) {
        clearInterval(interVal);
        try { sessionStorage.setItem('kjuup_notified_version', result.metaVersion); } catch (e) {}
        setNotifiedVersion(result.metaVersion); // Mark this version as notified
        setTimeout(async () => {
          await $crud.confirm({
            title: strings.update_availble,
            textContent: strings.update_text,
            options: {
              ok: strings.restart,
              cancel: ""
            },
          });
          _resetAndReload();
        }, 1000)
      }
    } catch (error) {
      console.error('Error checking version:', error);
    }
  };

  const _resetAndReload = () => {
    try {
      if (window.caches) {
        return caches.keys().then(function (cacheNames) {
          return Promise.all(
            cacheNames.map(function (cacheName) {
              return caches.delete(cacheName);
            })
          ).then(function () {
            console.log('The cache has been deleted.');
            window.location.reload(true);
          });
        });
      } else {
        console.log('Cache API not available, performing regular reload');
        window.location.reload(true);
        return Promise.resolve();
      }
    } catch (error) {
      console.log('Error clearing cache:', error);
      window.location.reload(true);
      return Promise.resolve();
    }
  }

  useEffect(() => {
    if (isImpersonating) return;
    // Dev-server HMR / Fast Refresh counts as a "reload" and would bounce the
    // tester off the email inbox back to the startup screen. Leave the current
    // route alone while developing.
    if (process.env.NODE_ENV === "development") {
      return;
    }

    // Check for page reload using both old and new Performance API
    const navEntries = performance.getEntriesByType("navigation");
    const isReload = (performance.navigation && performance.navigation.type === 1) || 
                     (navEntries[0]?.type === "reload");
    
    if (isReload) {
      console.log("Page reloaded - resetting to startup screen");
      console.log("Current pathname:", window.location.pathname);

      // Preserve deep links on full loads so startup-screen redirects don't
      // bounce email/notification clicks away before DeeplinkHandler runs.
      captureIncomingDeeplink();
      const hasArticleDeepLink = /scrollToArticle=/.test(window.location.search || "");
      const isChatDeepLink = isDeeplinkPath(window.location.pathname);

      const startupValue = getStartupScreenFromUser($user.get());
      const startup = getStartupRoute(startupValue);

      // Force redirect to preferred startup screen if not already there
      if (!hasArticleDeepLink && !isChatDeepLink && !getPendingDeeplink() && !isOnStartupScreen(startupValue, window.location.pathname)) {
        console.log("Forcing redirect to", startup.path);
        window.location.href = startup.path;
        return;
      }

      // Chat email deeplinks: leave routing to DeeplinkHandler.
      if (isChatDeepLink) {
        return;
      }
      
      // Clear all state
      dispatch({ type: OPEN_PROJECTS, projects: [] })
      dispatch({ type: OPEN_BOTTOM_PROJECTS, projects: [] })
      dispatch({ type: OPEN_CHATS, chats: [] })
      dispatch({ type: OPEN_BOTTOM_CHATS, chats: [] })
      dispatch({ type: RIGHT_TOP, rightTop: startup.sidebar === 'project1' ? 'project1' : '' })
      if (startup.sidebar === 'project1') {
        dispatch({ type: UPDATE_PROJECT_ACTION_FIRE, updateProjectActionFire: true })
      }
      dispatch({ type: SET_OPEN_SIDE_BAR, payload: hasArticleDeepLink ? 'articles' : startup.sidebar })
      
      // Normalize the cockpit alias to root (keep article deep links intact)
      if (!hasArticleDeepLink && startup.path === "/" && window.location.pathname === "/cockpit") {
        window.location.href = "/";
      }
      
      // Show ongoing calls if any
      if (runningCalls?.length > 0) {
        dispatch({ type: SHOW_LIST_ONGOING, payload: true })
      }
    }
  }, []);

  useEffect(() => {
    if (isImpersonating) return;
    // Force initial state on mount
    console.log("App mounted - setting initial state");
    captureIncomingDeeplink();
    const path = window.location.pathname;
    const hasArticleDeepLink = /scrollToArticle=/.test(window.location.search || "");
    const isChatDeepLink = isDeeplinkPath(path);
    // Chat email deeplinks: DeeplinkHandler owns sidebar + open chats.
    if (isChatDeepLink) {
      return;
    }
    const startupValue = getStartupScreenFromUser($user.get());
    const startup = getStartupRoute(startupValue);
    dispatch({ type: SET_OPEN_SIDE_BAR, payload: startup.sidebar })
    dispatch({ type: RIGHT_TOP, rightTop: startup.sidebar === 'project1' ? 'project1' : '' })
    if (startup.sidebar === 'project1') {
      dispatch({ type: UPDATE_PROJECT_ACTION_FIRE, updateProjectActionFire: true })
    }
    dispatch({ type: OPEN_PROJECTS, projects: [] })
    dispatch({ type: OPEN_CHATS, chats: [] })
    dispatch({ type: OPEN_BOTTOM_PROJECTS, projects: [] })
    dispatch({ type: OPEN_BOTTOM_CHATS, chats: [] })
    // Cold start / refresh on the root: land on the preferred startup screen,
    // unless we're opening an internal-article deep link (keep the feed + scroll).
    if (!hasArticleDeepLink && !getPendingDeeplink() && path === "/" && !isOnStartupScreen(startupValue, path)) {
      window.location.replace(startup.path);
    }
    if (hasArticleDeepLink) {
      dispatch({ type: SET_OPEN_SIDE_BAR, payload: 'articles' });
    }
  }, []);

  // Login sets a queued destination then flips the token; Login's nested Router
  // unmounts so history.push is lost — apply the queue here instead.
  useEffect(() => {
    if (!userLoginToken || isImpersonating) return;
    const currentPath = window.location.pathname;
    const pendingDeeplink = getPendingDeeplink();
    const onRestorablePath =
      currentPath === "/" ||
      currentPath === "/cockpit" ||
      currentPath === "/articles" ||
      currentPath === "/messages" ||
      isDeeplinkPath(currentPath);
    if (pendingDeeplink && !onRestorablePath) {
      return;
    }
    const queued = consumeQueuedStartupNavigation();
    if (!queued) return;
    dispatch({ type: SET_OPEN_SIDE_BAR, payload: queued.sidebar });
    if (!isDeeplinkPath(queued.path)) {
      dispatch({ type: RIGHT_TOP, rightTop: queued.sidebar === 'project1' ? 'project1' : '' });
      if (queued.sidebar === 'project1') {
        dispatch({ type: UPDATE_PROJECT_ACTION_FIRE, updateProjectActionFire: true });
      }
    }
    const current = window.location.pathname + (window.location.search || "");
    if (current !== queued.path) {
      window.location.replace(queued.path);
    }
  }, [userLoginToken, isImpersonating]);

  const getProfile = async () => {
    const { data } = await callAPI(`/user/profile`, {}, "GET");
    let profile = data?.profile;
    $user.updateUserData({ ...user, ...profile });
    if (data?.status) {
      $user.setProfile(data);
    }
    if (profile) {
      const clientLang = (localStorage.getItem('language') || '').split('-')[0].toLowerCase();
      const serverLang = (profile.language || 'en').split('-')[0].toLowerCase();
      if (clientLang && clientLang !== serverLang) {
        callAPI(`/user/language?lang=${clientLang}`, {}, 'PUT').catch(() => {});
      }

      // Auto translation is always enabled for all users — no disable path.
      dispatch({ type: SET_AUTO_TRANSLATION, status: true });
      localStorage.setItem("autoTrans", "true");
      dispatch({
        type: SET_TRANSLATE_ROOM_AND_GROUP_NAMES,
        status: !!profile.translateRoomAndGroupNames,
      });
      const appLang = (clientLang || serverLang || 'en');
      dispatch({ type: LANGUAGE, language: appLang });
      let enabledLangs = null;
      if (Array.isArray(profile.autoTranslationLanguages) && profile.autoTranslationLanguages.length > 0) {
        enabledLangs = profile.autoTranslationLanguages;
      } else {
        enabledLangs = null;
      }
      dispatch({ type: SET_AUTO_TRANSLATION_LANGUAGES, languages: enabledLangs });
      try {
        if (enabledLangs == null) {
          localStorage.removeItem('autoTranslationLanguages');
        } else {
          localStorage.setItem('autoTranslationLanguages', JSON.stringify(enabledLangs));
        }
      } catch (e) {}

      dispatch({ type: SET_DOCUMENT_CONTENT_SEARCH, status: !!profile.documentContentSearchEnabled });
      if (Array.isArray(profile.pinnedRooms)) {
        dispatch({ type: SET_PINNED_ROOMS, payload: profile.pinnedRooms });
      }
      if (profile.startupScreen) {
        persistStartupScreen(profile.startupScreen);
        $user.updateUserData({ ...($user.get() || {}), ...profile, startupScreen: profile.startupScreen });
      }
    }
  };

  useEffect(() => {
    console.log("Pathname changed to:", history.location.pathname);
    if (history.location.pathname === '/' || history.location.pathname === '/articles') {
      console.log("At feed path - forcing articles view");
      dispatch({ type: SET_OPEN_SIDE_BAR, payload: 'articles' });
      dispatch({ type: RIGHT_TOP, rightTop: '' });
      dispatch({ type: OPEN_PROJECTS, projects: [] });
      // Removed automatic redirect to /articles - allow staying at domain root
    } else if (history.location.pathname === '/messages') {
      dispatch({ type: SET_OPEN_SIDE_BAR, payload: 'LatestMessages' });
    }
  }, [history.location.pathname]);

  const _serColor = (color) => { /* implement your color logic or leave empty */ };

  const [shouldShowPin, setShouldShowPin] = useState(false)
  const [pin, setPin] = useState("")

  useEffect(() => {
    if (pin && pin.length === 4) {
      let isPinSet = localStorage.getItem("isPinSet")
      if (isPinSet === "true") {
        let actualPin = localStorage.getItem("pin")
        if (pin === actualPin) {
          setShouldShowPin(false)
          setIsLoggedIn(true);
        }
      }
    }
  }, [pin])

  const onCallEnded = () => {
    setUpdateCalls(!updateCalls)
  }

  const showList = useSelector(e => e.showListOngoing)

  // Full-screen branded loader while the admin "Sign in as user" flow is
  // running. Returned BEFORE any of the route-based renders below so the user
  // never sees the login screen or stale home screen during the transition.
  // For error variants the overlay stays visible until the user taps
  // "Got it" — we never auto-bounce them to /login.
  if (isImpersonating) {
    return (
      <ImpersonationLoader
        variant={impersonationVariant}
        status={impersonationStatus}
        subtext={impersonationSubtext}
        actionLabel="Got it"
        onAction={() => {
          setIsImpersonating(false);
          setImpersonationVariant('loading');
          setImpersonationStatus('Preparing your session…');
          setImpersonationSubtext('');
        }}
      />
    );
  }

  if (isLoggedIn === undefined || isLoggedIn) {
    return (
      <SocketContext.Provider value={Socket}>
        <LanguageProvider value={lgVal}>
          {isSearchOpen && <div className="app-blur-overlay" />}
          <Router>
            <DndProvider backend={HTML5Backend}>
            <DirectMessagePrompt />
            {!isDesktopResolution ? (
              <SafeArea style={{ flex: 1, display: "flex", minHeight: 0, height: "var(--app-height)", overflow: "hidden" }}>
                <SideNav toogleChat={toogleChat} />
                <div className="app-shell__row">
                  <div style={{ 
                    flex: (activeSideBar === 'project1' || activeSideBar === 'chat1') ? 0 : 1, 
                    minHeight: 0, 
                    overflowY: "auto", 
                    overflowX: "hidden", 
                    display: (activeSideBar === 'project1' || activeSideBar === 'chat1') ? 'none' : 'flex', 
                    flexDirection: "column" 
                  }}>
                  <MainColumn>
                  <Switch>
                    <Route exact path="/subscription" component={SubscriptionPage} />
                    <Route exact path="/people-likes/:id" component={ArticleLike} />
                    <Route exact path="/security-pin-main" component={SecurityPINMain} />
                    <Route exact path="/user-profile/:id" component={UserProfile} />
                    <Route exact path="/add-user/:id/:departmentId" component={CompanyUser} />
                    <Route exact path="/edit-profile" component={EditProfile} />
                    <Route exact path="/company-setting/:id/:deptId" component={CompanySetting} />
                    <Route exact path="/foreign-company-details/:id" component={ForeignCompanyDetails} />
                    <Route exact path="/companies" component={Companies} />
                    <Route exact path="/company-followers/:id" component={CompanyFollowers} />
                    <Route exact path="/followings" component={Followings} />
                    <Route exact path="/user-followings/:id" component={UserFollowings} />
                    <Route exact path="/followers" component={Followers} />
                    <Route exact path="/user-followers/:id" component={UserFollowers} />
                    <Route exact path="/add-company" component={AddCompany} />
                    <Route exact path="/edit-company/:id" component={EditCompany} />
                    <Route exact path="/company-user/:id" component={CompanyUser} />
                    <Route exact path="/company-admin/:id" component={CompanyAdmin} />
                    <Route exact path="/kjuup-io/:id" component={KjuupIoAboPage} />
                    <Route exact path="/add-project" component={AddProject} />
                    <Route exact path="/project" component={Project} />
                    <Route exact path="/project-detail/:id" component={ProjectDetail} />
                    <Route exact path="/add-project-user/:id" component={AddProjectUser} />
                    <Route exact path="/invite-project-user/:id" component={InviteProjectUser} />
                    <Route exact path="/media-links-docs/:id" component={MediaLinksDocs} />
                    <Route exact path="/feed-detail/:id" component={FeedDetail} />
                    <Route exact path="/edit-project/:id" component={EditProject} />
                    <Route exact path="/article-like/:id" component={ArticleLike} />
                    <Route exact path="/create-company-article" component={CreateCompanyArticle} />
                    <Route exact path="/edit-company-article/:id" component={EditCompanyArticle} />
                    <Route exact path="/add-one-to-one-user" component={AddOneToOneUser} />
                    <Route exact path="/follow-one-to-one/:id" component={FollowOneToOne} />
                    <Route exact path="/weekly-statistics" component={WeeklyStatistics} />
                    <Route exact path="/view-all" component={AllContact} />
                    <Route exact path="/demo" component={Home} />
                    <Route exact path="/contact" component={Contact} />
                    <Route exact path="/capacities" component={Capacities} />
                    <Route exact path="/free-capacity" component={FreeCapacity} />
                    <Route exact path="/company" component={Company} />
                    <Route exact path="/invite-user/:id/:departmentId" component={ExternalMit} />
                    <Route exact path="/service-members/:id" component={CompanyServicesMember} />
                    <Route exact path="/add-service/:id" component={AddServices} />
                    <Route exact path="/project-list" component={Project} />
                    <Route exact path="/one-to-one-chat-user" component={AddOneToOneUser} />
                    <Route exact path="/follow-one-to-one" component={FollowOneToOne} />
                    <Route exact path="/add-company-article/:id" component={CreateCompanyArticle} />
                    <Route exact path="/edit-company-article/:id/:articleId" component={EditCompanyArticle} />
                    <Route exact path="/deeplink" component={DeeplinkHandler} />
                    <Route
                      exact
                      path="/my-projects"
                      render={props => <MyProject {...props} changeBorder={_serColor} />}
                    />
                    <Route exact path="/info" component={InfoPage} />
                  </Switch>
                  </MainColumn>
                  </div>
                  <RightBar openChatToggle={openChatToggle} toogleChat={toogleChat} />
                </div>
              </SafeArea>
            ) : (
              <SafeArea style={{ flex: 1, display: "flex", minHeight: 0, height: "var(--app-height)", overflow: "hidden" }}>
                <SideNav toogleChat={toogleChat} />
                <div style={{ 
                  flex: (activeSideBar === 'project1' || activeSideBar === 'chat1') ? 0 : 1, 
                  minHeight: 0, 
                  overflowY: "auto", 
                  overflowX: "hidden", 
                  display: (activeSideBar === 'project1' || activeSideBar === 'chat1') ? 'none' : 'flex', 
                  flexDirection: "column" 
                }}>
                <MainColumn>
                <Switch>
                  <Route exact path="/subscription" component={SubscriptionPage} />
                  <Route exact path="/people-likes/:id" component={ArticleLike} />
                  <Route exact path="/security-pin-main" component={SecurityPINMain} />
                  <Route exact path="/user-profile/:id" component={UserProfile} />
                  <Route exact path="/add-user/:id/:departmentId" component={CompanyUser} />
                  <Route exact path="/edit-profile" component={EditProfile} />
                  <Route exact path="/company-setting/:id/:deptId" component={CompanySetting} />
                  <Route exact path="/foreign-company-details/:id" component={ForeignCompanyDetails} />
                  <Route exact path="/companies" component={Companies} />
                  <Route exact path="/company-followers/:id" component={CompanyFollowers} />
                  <Route exact path="/followings" component={Followings} />
                  <Route exact path="/user-followings/:id" component={UserFollowings} />
                  <Route exact path="/followers" component={Followers} />
                  <Route exact path="/user-followers/:id" component={UserFollowers} />
                  <Route exact path="/add-company" component={AddCompany} />
                  <Route exact path="/edit-company/:id" component={EditCompany} />
                  <Route exact path="/company-user/:id" component={CompanyUser} />
                  <Route exact path="/company-admin/:id" component={CompanyAdmin} />
                  <Route exact path="/kjuup-io/:id" component={KjuupIoAboPage} />
                  <Route exact path="/add-project" component={AddProject} />
                  <Route exact path="/project" component={Project} />
                  <Route exact path="/project-detail/:id" component={ProjectDetail} />
                  <Route exact path="/add-project-user/:id" component={AddProjectUser} />
                  <Route exact path="/invite-project-user/:id" component={InviteProjectUser} />
                  <Route exact path="/media-links-docs/:id" component={MediaLinksDocs} />
                  <Route exact path="/feed-detail/:id" component={FeedDetail} />
                  <Route exact path="/edit-project/:id" component={EditProject} />
                  <Route exact path="/article-like/:id" component={ArticleLike} />
                  <Route exact path="/create-company-article" component={CreateCompanyArticle} />
                  <Route exact path="/edit-company-article/:id" component={EditCompanyArticle} />
                  <Route exact path="/add-one-to-one-user" component={AddOneToOneUser} />
                  <Route exact path="/follow-one-to-one/:id" component={FollowOneToOne} />
                  <Route exact path="/weekly-statistics" component={WeeklyStatistics} />
                  <Route exact path="/view-all" component={AllContact} />
                  <Route exact path="/demo" component={Home} />
                  <Route exact path="/contact" component={Contact} />
                  <Route exact path="/capacities" component={Capacities} />
                  <Route exact path="/free-capacity" component={FreeCapacity} />
                  <Route exact path="/company" component={Company} />
                  <Route exact path="/invite-user/:id/:departmentId" component={ExternalMit} />
                  <Route exact path="/service-members/:id" component={CompanyServicesMember} />
                  <Route exact path="/add-service/:id" component={AddServices} />
                  <Route exact path="/project-list" component={Project} />
                  <Route exact path="/one-to-one-chat-user" component={AddOneToOneUser} />
                  <Route exact path="/follow-one-to-one" component={FollowOneToOne} />
                  <Route exact path="/add-company-article/:id" component={CreateCompanyArticle} />
                  <Route exact path="/edit-company-article/:id/:articleId" component={EditCompanyArticle} />
                  <Route exact path="/deeplink" component={DeeplinkHandler} />
                  <Route
                    exact
                    path="/my-projects"
                    render={props => <MyProject {...props} changeBorder={_serColor} />}
                  />
                  <Route exact path="/info" component={InfoPage} />
                </Switch>
                </MainColumn>
                </div>
                <RightBar openChatToggle={openChatToggle} toogleChat={toogleChat} />
              </SafeArea>
            )}
            </DndProvider>
          </Router>
          <ConfirmDialog />
          <CardonContainer />
          <NotifySnackbar autoHideDuration={5000} />
          <OngoingCallsListPopup />
          {props.ViewerImages && props.ViewerImages.length > 0 && (
            <div className="app-shell__viewer">
              <FullScreenImageViewer reduxImages={props.ViewerImages} />
            </div>
          )}
          {isLoading ?
            <div className="kj-loader-overlay">
              <div className="kj-loader-card">
                <div className="kj-loader-icon">
                  <div 
                    className={`kj-loader-pulse app-shell__loader-pulse${isInternalLoading ? ' app-shell__loader-pulse--internal' : ''}`}
                  ></div>
                  <div 
                    className={`kj-loader-circle app-shell__loader-circle${isInternalLoading ? ' app-shell__loader-circle--internal' : ''}`}
                  >
                    <svg className="kj-loader-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
                <div className="kj-loader-text">
                  {deeplinkLoadingMessage === 'navigating_to_room'
                    ? (strings.navigating_to_room || 'Navigating to the project')
                    : (isGerm ? 'Chat wird geladen...' : 'Chat is loading...')}
                  <div className="kj-loader-subtext">
                    {deeplinkLoadingMessage === 'navigating_to_room'
                      ? (strings.please_wait || (isGerm ? 'Einen Moment bitte...' : 'Please wait a moment...'))
                      : (isGerm ? 'Einen Moment bitte...' : 'Please wait a moment...')}
                  </div>
                </div>
              </div>
            </div>
            : <></>}
          <KjuupSupportModal />
          {globalLoader && <Loading />}
        </LanguageProvider>
      </SocketContext.Provider>
    );
  }

  if (isLoggedIn !== undefined) {
    if (!isLoggedIn) {
      captureIncomingDeeplink();
      return (
        <SocketContext.Provider value={Socket}>
          <LanguageProvider value={lgVal}>
            {!isDesktopResolution ? (
              <SafeArea>
                <div className="App">
                  <div className="fronpanel">
                    <Router>
                      <Switch>
                        <Route exact path="/">
                          <Login />
                        </Route>
                        <Route exact path="/register">
                          <Register />
                        </Route>
                        <Route exact path="/register-kjuup-io">
                          <Register kjuupIo />
                        </Route>
                        <Route exact path="/forgot-password">
                          <ForgotPassword />
                        </Route>
                        <Route exact path="/security-pin" component={SecurityPIN} />
                        <Route exact path="/two-factor" component={TwoFactorChallenge} />
                        <Route exact path="/info" component={InfoPage} />
                        <Route path="*" component={Login} />
                      </Switch>
                    </Router>
                  </div>
                </div>
              </SafeArea>
            ) : (
              <div className="App">
                <div className="fronpanel">
                  <Router>
                    <Switch>
                      <Route exact path="/">
                        <Login />
                      </Route>
                      <Route exact path="/register">
                        <Register />
                      </Route>
                      <Route exact path="/register-kjuup-io">
                        <Register kjuupIo />
                      </Route>
                      <Route exact path="/forgot-password">
                        <ForgotPassword />
                      </Route>
                      <Route exact path="/security-pin" component={SecurityPIN} />
                      <Route exact path="/two-factor" component={TwoFactorChallenge} />
                      <Route exact path="/info" component={InfoPage} />
                      <Route path="*" component={Login} />
                    </Switch>
                  </Router>
                </div>
              </div>
            )}
          </LanguageProvider>
        </SocketContext.Provider>
      );
    }
  }

}

const mapStateToProps = (state) => {
  const { unseenNewsCount, openChats = [], openBottomChats = [], ViewerImages, isJitsiCallStarted, user } = state;
  return {
    unseenNewsCount,
    openChats,
    openBottomChats,
    ViewerImages,
    isJitsiCallStarted,
    user,
    bookmarkTodoEventSeq: state.bookmarkTodoEventSeq,
    todoListRefreshTrigger: state.todoListRefreshTrigger,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateNewsCount: (count) =>
      dispatch({ type: NEWS_BADGE_COUNT, unseenNewsCount: count }),
    updateAllBadgeCount: (count) =>
      dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: count }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));